import React, { useState, useEffect, useCallback } from 'react';



import api from '../services/api';
import { localDateStr } from '../utils/dateUtils';



import { useDebounce } from '../hooks/useDebounce';



import Modal from '../components/common/Modal';



import Pagination from '../components/common/Pagination';



import { useAuth } from '../context/AuthContext';



import { useCompany } from '../context/CompanyContext';



import BulkUpload from '../components/common/BulkUpload';



import { generateInvoicePDF, generateProformaInvoicePDF, generatePurchaseOrderPDF } from '../utils/pdfGenerator';



import { useSavedFilters } from '../hooks/useSavedFilters';



import TypeaheadSelect from '../components/common/TypeaheadSelect';



import EntityHistory from '../components/common/EntityHistory';



import { useColumnVisibility } from '../hooks/useColumnVisibility';



import PODocumentParser from '../components/common/PODocumentParser';



import { INDIAN_STATES } from '../config/geoData';

import {
  statusColors, ORDER_TYPES, CURRENCIES, GST_RATES,
  CATALOG_CATEGORIES, PHARMACOPEIAS, catLbl,
  suggestGstRateFromHsn, autoFillParty, getTaxDefaults, gstAutoInfo,
  genQuoteNumber,
} from '../utils/orderUtils';

import { SkeletonTable } from '../components/common/Skeleton';



import { AddressFields } from '../components/orders/AddressField';



import CatalogCombobox from '../components/orders/CatalogCombobox';



import ShippingSection from '../components/orders/ShippingSection';



import PaymentModal from '../components/orders/PaymentModal';



import StatusUpdateModal from '../components/orders/StatusUpdateModal';







const emptyItem = { catalog_item_id: '', item_name: '', pack_size: '', batch_number: '', catalog_number: '', price: '', quantity: 1, discount_percent: 0 };







const defaultCols = ['order_num', 'type', 'client', 'total', 'status', 'created_by', 'date', 'actions'];



const COLS = [



  { key: 'order_num', label: 'Order #' },



  { key: 'type', label: 'Type' },



  { key: 'client', label: 'Client' },



  { key: 'total', label: 'Total' },



  { key: 'status', label: 'Status' },



  { key: 'created_by', label: 'Created By' },



  { key: 'date', label: 'Due Date' },



  { key: 'actions', label: 'Actions' },



];







const emptyNewProd = { name: '', category: 'impurity_standard', catalog_number: '', cas_number: '', pharmacopeia: 'In-house', pack_sizes: '', price: '', hsn_code: '', description: '', prasi_lab_catalog: false };







const defaultForm = {



  party_type: 'client', client_id: '', customer_id: '', contact_id: '',



  order_type: 'invoice', currency: 'INR',



  po_number: '', po_date: '', expected_delivery: '', payment_term: '', due_date: '', notes: '',



  shipping_address: '',



  discount_percent: 0, commission: 0, items: [{ ...emptyItem }],



  quote_number: '', quote_date: '',



  billing_address: '',



  freight_amount: 0, freight_gst_pct: 0, freight_detail: 'At our cost',



  transport: '', dispatch_doc_number: '', dispatch_doc_date: '', destination: '', terms_of_delivery: 'Door Delivery',



  charges: [], additional_info: '', client_gstin: '', client_state_code: '', client_phone: '',



  waybill_number: '', waybill_date: '',



  tax_type: 'igst', tax_rate: 18, tax_label: 'IGST',
  show_bank_details: false,



};







export default function Orders() {



  const { user, isPrivileged } = useAuth();



  const { companyCurrency, settings: companySettings } = useCompany();



  const [data, setData] = useState({ data: [], total: 0, page: 1, limit: 15 });



  const [loading, setLoading] = useState(true);



  const [search, setSearch] = useState('');



  const [statusFilter, setStatusFilter] = useState('');



  const [page, setPage] = useState(1);



  const [modal, setModal] = useState({ open: false, mode: 'add', editId: null });



  const [viewModal, setViewModal] = useState({ open: false, order: null });



  const [viewTab, setViewTab] = useState('details');



  const [statusModal, setStatusModal] = useState({ open: false, order: null, status: '' });
  const [revisingId, setRevisingId] = useState(null);



  const [docs, setDocs] = useState([]);



  const [docForm, setDocForm] = useState({ doc_type: 'po', doc_description: '', file: null });



  const [docUploading, setDocUploading] = useState(false);



  const [docError, setDocError] = useState('');



  const [clients, setClients] = useState([]);



  const [customers, setCustomers] = useState([]);



  const [entityContacts, setEntityContacts] = useState([]);



  const [savedAddresses, setSavedAddresses] = useState([]);



  const [catalogItems, setCatalogItems] = useState([]);



  const [newProdModal, setNewProdModal] = useState({ open: false, itemIndex: null });



  const [newProdForm, setNewProdForm] = useState({ ...emptyNewProd });



  const [newProdSaving, setNewProdSaving] = useState(false);



  const [newProdError, setNewProdError] = useState('');






  const [form, setForm] = useState({ ...defaultForm });



  const [saving, setSaving] = useState(false);



  const [error, setError] = useState('');



  const [bulkOpen, setBulkOpen] = useState({ open: false, type: 'invoice' });



  const [selectedIds, setSelectedIds] = useState([]);



  const [bulkStatus, setBulkStatus] = useState('');



  const [bulkApplying, setBulkApplying] = useState(false);



  const [toast, setToast] = useState('');



  const [creditMap, setCreditMap] = useState({});



  const [payModal, setPayModal] = useState({ open: false, order: null, amount: '', date: localDateStr(), method: 'bank_transfer', reference: '', notes: '', saving: false, error: '' });



  const [whatsappSending, setWhatsappSending] = useState(false);







  // Split order state



  const [splitModal, setSplitModal] = useState({ open: false, parent: null });



  const [splitForm, setSplitForm] = useState({ order_type: 'invoice', po_number: '', notes: '', discount_percent: 0, items: [] });



  const [splitSaving, setSplitSaving] = useState(false);



  const [splitError, setSplitError] = useState('');







  // Assignment + Work Log modal state



  const [assignModal, setAssignModal] = useState({ open: false, orderId: null, orderNum: '', ownerId: null });



  const [assignments, setAssignments] = useState([]);



  const [workLogs, setWorkLogs] = useState([]);



  const [assignUsers, setAssignUsers] = useState([]);



  const [assignTab, setAssignTab] = useState('assignments'); // 'assignments' | 'worklogs'



  const [assignForm, setAssignForm] = useState({ user_id: '', access_level: 'read_only', notes: '' });



  const [assignSaving, setAssignSaving] = useState(false);



  const [assignError, setAssignError] = useState('');



  const [wlForm, setWlForm] = useState({ log_type: 'note', log_text: '' });



  const [wlSaving, setWlSaving] = useState(false);



  const [wlError, setWlError] = useState('');







  // Related orders + link modal state



  const [linkModal, setLinkModal] = useState({ open: false, orderId: null, orderNum: '' });



  const [linkForm, setLinkForm] = useState({ relation_type: 'raw_material', notes: '' });



  const [linkQuery, setLinkQuery] = useState('');



  const [linkResults, setLinkResults] = useState([]);



  const [linkSelected, setLinkSelected] = useState(null); // { id, order_number, order_type, status }



  const [linkSaving, setLinkSaving] = useState(false);



  const [linkError, setLinkError] = useState('');



  const [genProformaLoading, setGenProformaLoading] = useState(false);







  // IRN / E-Way Bill state



  const [irnLoading, setIrnLoading] = useState(false);



  const [ewbLoading, setEwbLoading] = useState(false);



  const [irnError, setIrnError] = useState('');



  const [ewbError, setEwbError] = useState('');



  const [poReceive, setPoReceive] = useState({ vendor_invoice_no: '', vendor_invoice_date: '', po_number: '', due_date: '', file: null, saving: false, error: '' });







  const handleReceivePO = async () => {
    setPoReceive(p => ({ ...p, saving: true, error: '' }));
    try {
      await api.post(`/orders/${viewModal.order.id}/receive`, {
        vendor_invoice_no: poReceive.vendor_invoice_no,
        vendor_invoice_date: poReceive.vendor_invoice_date || null,
        invoice_no: poReceive.po_number || (viewModal.order?.status === 'confirmed' ? viewModal.order?.invoice_number : null) || null,
        invoice_date: null,
        due_date: poReceive.due_date || null,
      });
      if (poReceive.file) {
        const fd = new FormData();
        fd.append('file', poReceive.file);
        fd.append('doc_type', 'invoice');
        await api.post(`/orders/${viewModal.order.id}/documents`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        await loadDocs(viewModal.order.id);
      }
      const { data: refreshed } = await api.get(`/orders/${viewModal.order.id}`);
      setViewModal(v => ({ ...v, order: refreshed.data }));
      setPoReceive({ vendor_invoice_no: '', vendor_invoice_date: '', po_number: '', due_date: '', file: null, saving: false, error: '' });
      setToast('Material received. PO marked as delivered.');
      setTimeout(() => setToast(''), 4000);
      load();
    } catch (err) {
      setPoReceive(p => ({ ...p, saving: false, error: err.response?.data?.message || 'Failed to mark as received.' }));
    }
  };




  const handleGenerateIRN = async (orderId) => {



    setIrnLoading(true); setIrnError('');



    try {



      const { data: res } = await api.post(`/orders/${orderId}/irn`);



      // Refresh view modal order data



      const { data: refreshed } = await api.get(`/orders/${orderId}`);



      setViewModal(v => ({ ...v, order: refreshed.data }));



      setToast(`IRN generated: ${res.data?.irn_number || 'Success'}`);



      setTimeout(() => setToast(''), 4000);



      load();



    } catch (err) {



      setIrnError(err.response?.data?.message || 'IRN generation failed.');



    } finally { setIrnLoading(false); }



  };







  const handleCancelIRN = async (orderId) => {



    if (!window.confirm('Cancel this IRN? This action cannot be reversed.')) return;



    setIrnLoading(true); setIrnError('');



    try {



      await api.delete(`/orders/${orderId}/irn`);



      const { data: refreshed } = await api.get(`/orders/${orderId}`);



      setViewModal(v => ({ ...v, order: refreshed.data }));



      setToast('IRN cancelled successfully.');



      setTimeout(() => setToast(''), 3000);



      load();



    } catch (err) {



      setIrnError(err.response?.data?.message || 'IRN cancellation failed.');



    } finally { setIrnLoading(false); }



  };







  const handleGenerateEWB = async (orderId) => {



    setEwbLoading(true); setEwbError('');



    try {



      const { data: res } = await api.post(`/orders/${orderId}/ewb`);



      const { data: refreshed } = await api.get(`/orders/${orderId}`);



      setViewModal(v => ({ ...v, order: refreshed.data }));



      setToast(`E-Way Bill generated: ${res.data?.ewb_number || 'Success'}`);



      setTimeout(() => setToast(''), 4000);



      load();



    } catch (err) {



      setEwbError(err.response?.data?.message || 'E-Way Bill generation failed.');



    } finally { setEwbLoading(false); }



  };







  const handleSendWhatsapp = async (orderId) => {



    if (whatsappSending) return;



    setWhatsappSending(true);



    try {



      await api.post(`/orders/${orderId}/notify-whatsapp`);



      setToast('WhatsApp notification sent successfully.');



    } catch (err) {



      const msg = err.response?.data?.message || 'Failed to send WhatsApp notification.';



      setToast(msg);



    } finally { setWhatsappSending(false); }



  };







  /* ── Saved filters & column visibility ────────────────────── */



  const { presets: filterPresets, save: saveFilter, remove: removeFilter } = useSavedFilters('orders');



  const { visible: visibleCols, toggle: toggleCol } = useColumnVisibility('orders', defaultCols);
  const actualVisibleCols = visibleCols;

  const [colOpen, setColOpen] = useState(false);







  /* ── Load order list ──────────────────────────────────────── */



  const debouncedSearch = useDebounce(search, 300);

  const load = useCallback(async () => {

    setLoading(true);

    try {

      const { data: res } = await api.get('/orders', {

        params: { page, limit: 15, search: debouncedSearch || undefined, status: statusFilter || undefined },

      });

      // Sort orders to put pending orders at the top
      const sortedData = {
        ...res,
        data: (res.data || []).sort((a, b) => {
          // Pending orders first
          if (a.status === 'pending' && b.status !== 'pending') return -1;
          if (a.status !== 'pending' && b.status === 'pending') return 1;
          // Within same status, sort by creation date (newest first)
          return new Date(b.created_at || 0) - new Date(a.created_at || 0);
        })
      };

      setData(sortedData);

    } finally { setLoading(false); }

  }, [page, debouncedSearch, statusFilter]);

  useEffect(() => { load(); }, [load]);







  /* ── Load shared data ─────────────────────────────────────── */



  const loadFormData = async () => {



    try {



      const [cl, cu, cat, creditRes] = await Promise.all([



        api.get('/clients', { params: { limit: 200, approval_status: 'approved' } }),



        api.get('/customers', { params: { limit: 200 } }),



        api.get('/catalog/active'),



        api.get('/clients/credit-status').catch(() => ({ data: [] })),



      ]);



      setClients((cl.data.data || []).sort((a, b) => (a.name || '').localeCompare(b.name || '')));



      setCustomers((cu.data.data || []).sort((a, b) => (a.name || '').localeCompare(b.name || '')));



      setCatalogItems(cat.data.data || []);



      // Build credit map keyed by `${entity_type}-${id}`



      const map = {};



      (Array.isArray(creditRes.data) ? creditRes.data : []).forEach(entry => {



        const key = `${entry.entity_type || 'client'}-${entry.id}`;



        map[key] = entry;



      });



      setCreditMap(map);



    } catch (err) {



      setError('Failed to load form data. Please try again.');



    }



  };







  const loadEntityAddresses = async (entityType, entityId) => {



    if (!entityId) { setSavedAddresses([]); return; }



    try {



      const { data } = await api.get('/addresses', { params: { entity_type: entityType, entity_id: entityId } });



      setSavedAddresses(data.data || []);



    } catch { setSavedAddresses([]); }



  };







  const loadEntityContacts = async (entityType, entityId) => {



    if (entityType !== 'client' || !entityId) { setEntityContacts([]); return; }



    try {



      const { data } = await api.get(`/clients/${entityId}/contacts`);



      setEntityContacts(data.data || []);



    } catch { setEntityContacts([]); }



  };







  /* ── Link-order search ───────────────────────────────────── */



  const searchOrdersForLink = async (q) => {



    setLinkQuery(q);



    setLinkSelected(null);



    if (!q || q.trim().length < 2) { setLinkResults([]); return; }



    try {



      const { data } = await api.get('/orders', { params: { search: q.trim(), limit: 8 } });



      setLinkResults(data.data || []);



    } catch { setLinkResults([]); }



  };







  const openLinkModal = (order) => {



    setLinkModal({ open: true, orderId: order.id, orderNum: order.order_number });



    setLinkForm({ relation_type: 'raw_material', notes: '' });



    setLinkQuery(''); setLinkResults([]); setLinkSelected(null);



    setLinkError('');



  };







  const handleAddRelation = async () => {



    if (!linkSelected) { setLinkError('Please search and select an order to link.'); return; }



    if (linkSelected.id === linkModal.orderId) { setLinkError('An order cannot be linked to itself.'); return; }



    setLinkSaving(true); setLinkError('');



    try {



      await api.post(`/orders/${linkModal.orderId}/relations`, {



        related_order_id: linkSelected.id,



        relation_type: linkForm.relation_type,



        notes: linkForm.notes || undefined,



      });



      setLinkModal({ open: false, orderId: null, orderNum: '' });



      // Refresh view modal if open



      if (viewModal.open && viewModal.order) {



        const { data: r } = await api.get(`/orders/${viewModal.order.id}`);



        setViewModal(v => ({ ...v, order: r.data }));



      }



      load();



    } catch (err) {



      setLinkError(err.response?.data?.message || 'Failed to link orders.');



    } finally { setLinkSaving(false); }



  };







  const handleRemoveRelation = async (orderId, relationId) => {



    try {



      await api.delete(`/orders/${orderId}/relations/${relationId}`);



      const { data: r } = await api.get(`/orders/${orderId}`);



      setViewModal(v => ({ ...v, order: r.data }));



    } catch { /* silent */ }



  };







  const handleGenerateProforma = async (orderId) => {



    if (!window.confirm('Generate a Proforma Invoice from this Tax Invoice?')) return;



    setGenProformaLoading(true);



    try {



      const { data: r } = await api.post(`/orders/${orderId}/generate-proforma`);



      alert(`Proforma Invoice ${r.data.order_number} created successfully.`);



      // Refresh view modal



      const { data: updated } = await api.get(`/orders/${orderId}`);



      setViewModal(v => ({ ...v, order: updated.data }));



      load();



    } catch (err) {



      const msg = err.response?.data?.message || 'Failed to generate proforma.';



      alert(msg);



    } finally {



      setGenProformaLoading(false);



    }



  };







  /* ── Open "New Order" modal ───────────────────────────────── */



  const openAdd = async () => {



    await loadFormData();



    setForm({ ...defaultForm, currency: companyCurrency, items: [{ ...emptyItem }], quote_number: genQuoteNumber() });



    setSavedAddresses([]);



    setEntityContacts([]);



    setError('');



    setModal({ open: true, mode: 'add', editId: null });



  };







  /* ── Open "Edit Order" modal (pending only) ───────────────── */



  const openEdit = async (o) => {



    await loadFormData();



    const { data: res } = await api.get(`/orders/${o.id}`);



    const ord = res.data;



    setForm({



      party_type: ord.party_type || 'client',



      client_id: ord.client_id || '',



      customer_id: ord.customer_id || '',



      order_type: ord.order_type || 'invoice',



      currency: ord.currency || 'INR',



      po_number: ord.po_number || '',



      po_date: ord.po_date ? ord.po_date.split('T')[0] : '',



      expected_delivery: ord.expected_delivery ? ord.expected_delivery.split('T')[0] : '',



      notes: ord.notes || '',



      discount_percent: ord.discount_percent || 0,



      ...(['invoice', 'proforma_invoice'].includes(ord.order_type) && { commission: ord.commission || 0 }),



      items: (ord.items || []).map(it => ({



        catalog_item_id: it.catalog_item_id,



        item_name: it.item_name || '',



        pack_size: it.pack_size || '',



        batch_number: it.batch_number || '',



        catalog_number: it.catalog_number || '',



        price: it.price,



        quantity: it.quantity,



        discount_percent: it.discount_percent || 0,



      })),



      quote_number: ord.quote_number || '',



      quote_date: ord.quote_date ? ord.quote_date.split('T')[0] : '',



      billing_address: ord.billing_address || '',



      shipping_address: ord.shipping_address || '',



      freight_amount: ord.freight_amount || 0,



      freight_gst_pct: ord.freight_gst_pct || 0,



      freight_detail: ord.freight_detail || '',



      transport: ord.transport || '',



      dispatch_doc_number: ord.dispatch_doc_number || '',



      dispatch_doc_date: ord.dispatch_doc_date ? ord.dispatch_doc_date.slice(0, 10) : '',



      destination: ord.destination || '',



      terms_of_delivery: ord.terms_of_delivery || '',



      payment_term: ord.payment_term || '',

      due_date: ord.due_date ? ord.due_date.split('T')[0] : '',



      charges: Array.isArray(ord.charges) && ord.charges.length > 0 ? ord.charges : (Number(ord.other_charges) > 0 ? [{ label: 'Other Charges', amount: ord.other_charges }] : []),



      additional_info: ord.additional_info || '',



      client_gstin: ord.client_gstin || '',



      client_state_code: ord.client_state_code || '',



      client_phone: ord.client_phone || '',



      waybill_number: ord.waybill_number || '',



      waybill_date: ord.waybill_date ? ord.waybill_date.split('T')[0] : '',



      tax_type: ord.tax_type || 'none',



      tax_rate: ord.tax_rate || 0,



      tax_label: ord.tax_label || '',



      contact_id: ord.contact_id || '',



      show_bank_details: ord.show_bank_details || false,



    });



    setError('');



    const entityType = ord.party_type === 'customer' ? 'customer' : 'client';



    const entityId = ord.party_type === 'customer' ? ord.customer_id : ord.client_id;



    await Promise.all([



      loadEntityAddresses(entityType, entityId),



      loadEntityContacts(entityType, entityId),



    ]);



    setModal({ open: true, mode: 'edit', editId: o.id });



  };







  /* ── View order details ───────────────────────────────────── */



  const openView = async (o) => {



    const { data: res } = await api.get(`/orders/${o.id}`);



    setViewModal({ open: true, order: res.data });



    setViewTab('details');



    setDocForm({ doc_type: 'po', doc_description: '', file: null });



    setDocError('');



    setIrnError('');



    setEwbError('');



    const { data: docsRes } = await api.get(`/orders/${o.id}/documents`);



    setDocs(docsRes.data || []);



  };







  const loadDocs = async (orderId) => {



    const { data: docsRes } = await api.get(`/orders/${orderId}/documents`);



    setDocs(docsRes.data || []);



  };







  /* ── Assignments & Work Logs ─────────────────────────────── */



  const openAssignModal = async (o) => {



    setAssignModal({ open: true, orderId: o.id, orderNum: o.order_number, ownerId: o.user_id });



    setAssignTab('assignments');



    setAssignForm({ user_id: '', access_level: 'read_only', notes: '' });



    setAssignError('');



    setWlForm({ log_type: 'note', log_text: '' });



    setWlError('');



    const [aRes, wlRes, usersRes] = await Promise.all([



      api.get(`/orders/${o.id}/assignments`),



      api.get(`/orders/${o.id}/work-logs`),



      api.get('/users/dropdown').catch(() => ({ data: { data: [] } })),



    ]);



    setAssignments(aRes.data.data || []);



    setWorkLogs(wlRes.data.data || []);



    setAssignUsers(usersRes.data.data || []);



  };







  const handleAddAssignment = async () => {



    if (!assignForm.user_id) { setAssignError('Please select a user.'); return; }



    setAssignSaving(true); setAssignError('');



    try {



      await api.post(`/orders/${assignModal.orderId}/assignments`, assignForm);



      const { data: r } = await api.get(`/orders/${assignModal.orderId}/assignments`);



      setAssignments(r.data || []);



      setAssignForm({ user_id: '', access_level: 'read_only', notes: '' });



    } catch (err) {



      setAssignError(err.response?.data?.message || 'Failed to add assignment.');



    } finally { setAssignSaving(false); }



  };







  const handleUpdateAssignment = async (assignId, access_level) => {



    try {



      await api.put(`/orders/${assignModal.orderId}/assignments/${assignId}`, { access_level });



      setAssignments(prev => prev.map(a => a.id === assignId ? { ...a, access_level } : a));



    } catch (err) {



      setAssignError(err.response?.data?.message || 'Failed to update assignment.');



    }



  };







  const handleRemoveAssignment = async (assignId, userName) => {



    if (!window.confirm(`Remove ${userName} from this order?`)) return;



    try {



      await api.delete(`/orders/${assignModal.orderId}/assignments/${assignId}`);



      setAssignments(prev => prev.filter(a => a.id !== assignId));



    } catch (err) {



      setAssignError(err.response?.data?.message || 'Failed to remove assignment.');



    }



  };







  const handleAddWorkLog = async () => {



    if (!wlForm.log_text.trim()) { setWlError('Please enter a log entry.'); return; }



    setWlSaving(true); setWlError('');



    try {



      await api.post(`/orders/${assignModal.orderId}/work-logs`, wlForm);



      const { data: r } = await api.get(`/orders/${assignModal.orderId}/work-logs`);



      setWorkLogs(r.data || []);



      setWlForm({ log_type: 'note', log_text: '' });



    } catch (err) {



      setWlError(err.response?.data?.message || 'Failed to add work log.');



    } finally { setWlSaving(false); }



  };







  const handleDeleteWorkLog = async (logId) => {



    if (!window.confirm('Delete this work log?')) return;



    try {



      await api.delete(`/orders/${assignModal.orderId}/work-logs/${logId}`);



      setWorkLogs(prev => prev.filter(l => l.id !== logId));



    } catch (err) {



      setWlError(err.response?.data?.message || 'Failed to delete work log.');



    }



  };







  /* ── Split order ─────────────────────────────────────────── */



  const openSplitModal = (order) => {



    // Default child type: opposite of parent (PO → Invoice; Invoice → PO; Proforma → Invoice)



    const defaultType = order.order_type === 'purchase_order' ? 'invoice'



      : order.order_type === 'invoice' ? 'purchase_order'



        : 'invoice';



    setSplitForm({



      order_type: defaultType,



      po_number: '',



      notes: '',



      discount_percent: order.discount_percent || 0,



      items: (order.items || []).map(it => ({



        catalog_item_id: it.catalog_item_id,



        item_name: it.item_name || '',



        pack_size: it.pack_size || '',



        batch_number: it.batch_number || '',



        catalog_number: it.catalog_number || '',



        price: it.price,



        quantity: it.quantity,



        discount_percent: it.discount_percent || 0,



        split_qty: it.quantity,   // editable



        included: true,



      })),



    });



    setSplitError('');



    setSplitModal({ open: true, parent: order });



  };







  const handleSplit = async () => {



    const included = splitForm.items.filter(it => it.included && Number(it.split_qty) > 0);



    if (included.length === 0) { setSplitError('Select at least one item with quantity > 0.'); return; }



    setSplitSaving(true); setSplitError('');



    try {



      const { data: res } = await api.post(`/orders/${splitModal.parent.id}/split`, {



        order_type: splitForm.order_type,



        po_number: splitForm.po_number || undefined,



        notes: splitForm.notes || undefined,



        discount_percent: Number(splitForm.discount_percent) || 0,



        items: included.map(it => ({



          catalog_item_id: it.catalog_item_id,



          pack_size: it.pack_size,



          batch_number: it.batch_number,



          price: it.price,



          quantity: Number(it.split_qty),



          discount_percent: it.discount_percent || 0,



        })),



      });



      setSplitModal({ open: false, parent: null });



      setToast(`Split order ${res.data.order_number} created.`);



      setTimeout(() => setToast(''), 4000);



      load();



      // Refresh the view modal if the parent is still open



      if (viewModal.open && viewModal.order?.id === splitModal.parent.id) {



        const { data: refreshed } = await api.get(`/orders/${splitModal.parent.id}`);



        setViewModal(v => ({ ...v, order: refreshed.data }));



      }



    } catch (err) {



      setSplitError(err.response?.data?.message || 'Failed to create split order.');



    } finally { setSplitSaving(false); }



  };







  /* ── Revise a confirmed order ─────────────────────────────── */



  const handleRevise = async (o) => {



    if (!window.confirm(`Revise order ${o.order_number}?\n\nThe current order will become read-only (status: Revised) and a new pending copy will be created for editing.`)) return;

    setRevisingId(o.id);

    try {



      const { data: res } = await api.post(`/orders/${o.id}/revise`);



      load();
      alert(`Revision created: ${res.data.order_number}`);



    } catch (err) {



      alert(err.response?.data?.message || 'Failed to revise order.');



    } finally {
      setRevisingId(null);
    }



  };







  const handleClone = async (o) => {



    try {



      await api.post(`/orders/${o.id}/clone`);



      setToast('Order cloned successfully');



      setTimeout(() => setToast(''), 3000);



      load();



    } catch (err) {



      alert(err.response?.data?.message || 'Failed to clone order.');



    }



  };







  const openPayModal = (order) => {



    setPayModal({ open: true, order, amount: Number(order.total || 0).toFixed(2), date: localDateStr(), method: 'bank_transfer', reference: '', notes: '', saving: false, error: '' });



  };







  const handleRecordPayment = async () => {



    if (!payModal.amount || isNaN(Number(payModal.amount)) || Number(payModal.amount) <= 0) {



      setPayModal(p => ({ ...p, error: 'Enter a valid amount.' })); return;



    }



    setPayModal(p => ({ ...p, saving: true, error: '' }));



    try {



      const o = payModal.order;



      await api.post('/accounting/payments', {



        order_id: o.id,



        client_id: o.client_id || null,



        amount: Number(payModal.amount),



        currency: o.currency || 'INR',



        payment_date: payModal.date,



        method: payModal.method,



        reference: payModal.reference || undefined,



        notes: payModal.notes || undefined,



      });



      setPayModal(p => ({ ...p, open: false }));



      setToast('Payment recorded successfully');



      setTimeout(() => setToast(''), 3000);



    } catch (err) {



      setPayModal(p => ({ ...p, saving: false, error: err.response?.data?.message || 'Failed to record payment.' }));



    }



  };







  const handleBulkStatus = async () => {



    if (!bulkStatus) { alert('Please select a status.'); return; }



    setBulkApplying(true);



    try {



      await api.patch('/orders/bulk-status', { ids: selectedIds, status: bulkStatus });



      setToast(`${selectedIds.length} order(s) updated to "${bulkStatus}"`);



      setTimeout(() => setToast(''), 3000);



      setSelectedIds([]);



      setBulkStatus('');



      load();



    } catch (err) {



      alert(err.response?.data?.message || 'Failed to update status.');



    } finally { setBulkApplying(false); }



  };







  const toggleSelect = (id) => setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);



  const toggleSelectAll = () => {



    const pageIds = data.data.map(o => o.id);



    const allSelected = pageIds.every(id => selectedIds.includes(id));



    setSelectedIds(allSelected ? selectedIds.filter(id => !pageIds.includes(id)) : [...new Set([...selectedIds, ...pageIds])]);



  };







  const handleDocUpload = async () => {



    if (!docForm.file) { setDocError('Please select a file.'); return; }



    if (docForm.doc_type === 'others' && !docForm.doc_description.trim()) {



      setDocError('Please describe the document type.'); return;



    }



    setDocUploading(true); setDocError('');



    try {



      const fd = new FormData();



      fd.append('file', docForm.file);



      fd.append('doc_type', docForm.doc_type);



      if (docForm.doc_description) fd.append('doc_description', docForm.doc_description);



      await api.post(`/orders/${viewModal.order.id}/documents`, fd, {



        headers: { 'Content-Type': 'multipart/form-data' },



      });



      setDocForm({ doc_type: 'po', doc_description: '', file: null });



      await loadDocs(viewModal.order.id);



    } catch (err) {



      setDocError(err.response?.data?.message || 'Upload failed.');



    } finally { setDocUploading(false); }



  };







  const handleDocDelete = async (docId) => {



    if (!window.confirm('Delete this document?')) return;



    try {



      await api.delete(`/orders/${viewModal.order.id}/documents/${docId}`);



      await loadDocs(viewModal.order.id);



    } catch (err) {



      setDocError(err.response?.data?.message || 'Delete failed.');



    }



  };







  const handleDocDownload = async (docId, name) => {



    try {



      const token = localStorage.getItem('token');



      const base = api.defaults.baseURL || '/api';



      const url = `${base}/orders/${viewModal.order.id}/documents/${docId}/download`;



      const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });



      if (!r.ok) throw new Error('Download failed');



      const blob = await r.blob();



      const a = document.createElement('a');



      a.href = URL.createObjectURL(blob);



      a.download = name;



      a.click();



    } catch {



      setDocError('Download failed. Please try again.');



    }



  };







  /* ── Item helpers ─────────────────────────────────────────── */



  const addItem = () => setForm(p => ({ ...p, items: [...p.items, { ...emptyItem }] }));



  const removeItem = (i) => setForm(p => ({ ...p, items: p.items.filter((_, idx) => idx !== i) }));







  const setItem = (i, key, value) => {
    setForm(p => {
      const items = [...p.items];
      items[i] = { ...items[i], [key]: value };

      if (key === 'catalog_item_id') {
        const cat = catalogItems.find(c => c.id === Number(value));
        if (cat) {
          items[i] = { ...items[i], item_name: cat.name, price: cat.price || '', pack_size: '', hsn_code: cat.hsn_code || '' };
        }
      }

      return { ...p, items };
    });
  };







  /* ── New-product-inline handlers ─────────────────────────── */



  const handleItemCatalogChange = (i, value) => {



    if (value === '__new__') {



      setNewProdForm({ ...emptyNewProd });



      setNewProdError('');



      setNewProdModal({ open: true, itemIndex: i });



      return;



    }



    setItem(i, 'catalog_item_id', value);


  };

  const handleSaveNewProduct = async () => { 



    if (!newProdForm.name.trim()) { setNewProdError('Product name is required.'); return; }



    if (!newProdForm.category) { setNewProdError('Category is required.'); return; }



    setNewProdSaving(true); setNewProdError('');



    try {



      const payload = {



        ...newProdForm,



        price: newProdForm.price || null,



        currency: companyCurrency,



      };



      const { data } = await api.post('/catalog', payload);



      const created = data.data;



      // Add to local catalog list so it appears in all dropdowns immediately



      setCatalogItems(prev => [...prev, created]);



      // Select it on the line item that triggered the modal



      const i = newProdModal.itemIndex;



      setForm(p => {



        const items = [...p.items];



        items[i] = { ...items[i], catalog_item_id: created.id, item_name: created.name, price: created.price || '', pack_size: '', hsn_code: created.hsn_code || '' };



        return { ...p, items };



      });



      setNewProdModal({ open: false, itemIndex: null });



    } catch (err) {



      setNewProdError(err?.response?.data?.message || err?.response?.data?.errors?.[0]?.msg || 'Failed to create product.');



    } finally {



      setNewProdSaving(false);



    }



  };







  /* ── Tax helpers ──────────────────────────────────────────── */



  const isIndianOrder = form.currency === 'INR';







  const onCurrencyChange = (cur) => {



    const taxDefaults = getTaxDefaults(cur, form.client_state_code, form.tax_rate);

    // Clear SWIFT/bank flag when switching back to INR
    const swiftReset = cur === 'INR' ? { show_bank_details: false } : {};

    setForm(p => ({ ...p, currency: cur, ...taxDefaults, ...swiftReset }));



  };







  const onTaxTypeChange = (taxType) => {



    let rate = form.tax_rate;



    let label = form.tax_label;



    if (taxType === 'export' || taxType === 'none') { rate = 0; label = taxType === 'export' ? 'Export/LUT' : ''; }



    else if (taxType === 'igst') { label = `IGST`; }



    else if (taxType === 'cgst_sgst') { label = 'CGST+SGST'; }



    setForm(p => ({ ...p, tax_type: taxType, tax_rate: rate, tax_label: label }));



  };







  const onTaxRateChange = (rate) => {



    const r = Number(rate) || 0;



    let label = form.tax_label;



    if (form.tax_type === 'igst') label = `IGST`;



    else if (form.tax_type === 'cgst_sgst') label = `CGST+SGST`;



    setForm(p => ({ ...p, tax_rate: r, tax_label: label }));



  };







  /* ── Totals ───────────────────────────────────────────────── */



  const calcLine = (it) => (Number(it.price) || 0) * (Number(it.quantity) || 0) * (1 - (Number(it.discount_percent) || 0) / 100);

  const subtotal = form.items.reduce((s, it) => s + calcLine(it), 0);



  const discAmt = subtotal * (Number(form.discount_percent) || 0) / 100;



  const taxableAmt = subtotal - discAmt;



  const taxRate = (form.tax_type === 'export' || form.tax_type === 'none') ? 0 : (Number(form.tax_rate) || 0);



  const taxAmt = taxableAmt * taxRate / 100;



  const freightAmt = Number(form.freight_amount) || 0;



  const freightGst = freightAmt * (Number(form.freight_gst_pct) || 0) / 100;



  const chargesTotal = (form.charges || []).reduce((s, c) => s + (Number(c.amount) || 0), 0);



  const chargesGstAmt = (form.charges || []).reduce((s, c) => s + (Number(c.amount) || 0) * (Number(c.gst_pct) || 0) / 100, 0);



  const grandTotal = taxableAmt + taxAmt + freightAmt + freightGst + chargesTotal + chargesGstAmt;







  /* ── Submit ───────────────────────────────────────────────── */



  const handleSave = async () => {



    if (form.party_type === 'client' && !form.client_id) { setError('Please select a client.'); return; }



    if (form.party_type === 'customer' && !form.customer_id) { setError('Please select a customer.'); return; }



    if (form.items.some(it => !it.catalog_item_id || !it.quantity || !it.price)) {



      setError('All item fields (product, qty, price) are required.'); return;



    }



    setSaving(true); setError('');



    const payload = {



      party_type: form.party_type,



      client_id: form.party_type === 'client' ? Number(form.client_id) : undefined,



      customer_id: form.party_type === 'customer' ? Number(form.customer_id) : undefined,



      contact_id: form.contact_id ? Number(form.contact_id) : undefined,



      order_type: form.order_type,



      currency: form.currency,



      po_number: form.po_number || undefined,



      po_date: form.po_date || undefined,



      expected_delivery: form.expected_delivery || undefined,



      payment_term: form.payment_term || undefined,

      ...(form.order_type === 'proforma_invoice' && { due_date: form.due_date || undefined }),



      notes: form.notes || undefined,



      discount_percent: Number(form.discount_percent) || 0,



      ...(['invoice', 'proforma_invoice'].includes(form.order_type) && { commission: Number(form.commission) || 0 }),



      quote_number: form.quote_number || undefined,



      quote_date: form.quote_date || undefined,



      billing_address: form.billing_address || undefined,



      shipping_address: form.shipping_address || undefined,



      freight_amount: Number(form.freight_amount) || 0,



      freight_gst_pct: Number(form.freight_gst_pct) || 0,



      freight_detail: form.freight_detail || undefined,



      transport: form.transport || undefined,



      dispatch_doc_number: form.dispatch_doc_number || undefined,



      dispatch_doc_date: form.dispatch_doc_date || undefined,



      destination: form.destination || undefined,



      terms_of_delivery: form.terms_of_delivery || undefined,



      charges: (form.charges || []).filter(c => c.label || Number(c.amount) > 0),



      additional_info: form.additional_info || undefined,



      client_gstin: form.client_gstin || undefined,



      client_state_code: form.client_state_code || undefined,



      client_phone: form.client_phone || undefined,



      waybill_number: form.waybill_number || undefined,



      waybill_date: form.waybill_date || undefined,



      tax_type: form.tax_type,



      tax_rate: taxRate,



      tax_label: form.tax_label || undefined,



      show_bank_details: form.show_bank_details || false,



      items: form.items.map(it => ({
        catalog_item_id: Number(it.catalog_item_id),
        item_name: it.item_name || undefined,
        pack_size: it.pack_size || undefined,
        batch_number: it.batch_number || undefined,
        hsn_code: it.hsn_code || undefined,
        ...(form.order_type === 'purchase_order' && it.catalog_number ? { catalog_number: it.catalog_number } : {}),
        quantity: Number(it.quantity),
        price: Number(it.price),
        discount_percent: Number(it.discount_percent) || 0,
      })),

    };

    try {
      if (modal.mode === 'add') {
        await api.post('/orders', payload);
      } else {
        await api.put(`/orders/${modal.editId}`, payload);
      }

      setModal({ open: false, mode: 'add', editId: null });



      load();



    } catch (err) {



      setError(err.response?.data?.message || (modal.mode === 'add' ? 'Failed to create order.' : 'Failed to update order.'));



    } finally { setSaving(false); }



  };







  /* ── Status update ────────────────────────────────────────── */

const handleStatus = async () => {



  const { order, status } = statusModal;



  try {



    await api.patch(`/orders/${order.id}/status`, { status });



    setStatusModal({ open: false, order: null, status: '' });



    load();



    // Update PO number when order is confirmed
    if (status === 'confirmed' && order.order_type === 'purchase_order') {
      const { data: updatedOrder } = await api.get(`/orders/${order.id}`);
      if (updatedOrder.data.invoice_number) {
        // Update the form with the auto-generated PO number if modal is open
        if (modal.open && modal.editId === order.id) {
          setForm(prev => ({ ...prev, po_number: updatedOrder.data.invoice_number }));
        }
        // Also update the displayed PO number in the view modal if it's currently open for this order
        if (viewModal.open && viewModal.order.id === order.id) {
          setViewModal(prev => ({ ...prev, order: { ...prev.order, po_number: updatedOrder.data.invoice_number } }));
        }
      }
    }

    if (status === 'delivered') {
      const { data: res } = await api.get(`/orders/${order.id}`);

      if (order.order_type === 'purchase_order') {
        await generatePurchaseOrderPDF(res.data);
      } else if (order.order_type === 'invoice') {
        await generateInvoicePDF(res.data);
      } else if (order.order_type === 'proforma_invoice') {
        await generateProformaInvoicePDF(res.data);
      }
    }

  } catch (err) {
    alert(err.response?.data?.message || 'Failed to update status.');
  }

};







  /* ── File icon helper ─────────────────────────────────────── */



  const docTypeIcon = (filename = '') => {



    const ext = filename.split('.').pop().toLowerCase();



    if (ext === 'pdf') return '📄';



    if (['doc', 'docx'].includes(ext)) return '📝';



    if (['xls', 'xlsx'].includes(ext)) return '📊';



    if (['png', 'jpg', 'jpeg', 'webp'].includes(ext)) return '🖼️';



    return '📎';



  };







  /* ── Tax display helper for form ──────────────────────────── */



  const TaxPanel = () => (



    <div style={{ minWidth: 240, background: 'var(--surface-2)', borderRadius: 10, padding: '12px 16px', border: '1px solid var(--border)' }}>



      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: '0.83rem' }}>



        <span style={{ color: 'var(--text-muted)' }}>Subtotal</span>



        <span>{form.currency} {subtotal.toFixed(2)}</span>



      </div>



      {discAmt > 0 && (



        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: '0.83rem' }}>



          <span style={{ color: 'var(--error)' }}>Discount ({form.discount_percent}%)</span>



          <span style={{ color: 'var(--error)' }}>−{form.currency} {discAmt.toFixed(2)}</span>



        </div>



      )}



      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: '0.83rem', fontWeight: 600 }}>



        <span style={{ color: 'var(--text-muted)' }}>Taxable Amount</span>



        <span>{form.currency} {taxableAmt.toFixed(2)}</span>



      </div>







      {/* Tax inputs */}



      <div style={{ borderTop: '1px solid var(--border)', paddingTop: 8, marginBottom: 6 }}>



        {isIndianOrder ? (() => {



          const autoInfo = gstAutoInfo(form.currency, form.client_state_code, form.client_gstin);



          const isExport = form.tax_type === 'export';



          const hsnSuggest = suggestGstRateFromHsn(form.items, catalogItems);



          const showHsnSuggest = hsnSuggest && !isExport && hsnSuggest.rate !== Number(form.tax_rate);



          return (



            <>



              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>



                <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Indian GST</div>



                <span style={{ fontSize: '0.68rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>Auto-determined</span>



              </div>







              {/* HSN-based rate suggestion */}



              {showHsnSuggest && (



                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 7, padding: '5px 9px', borderRadius: 6, background: '#fefce8', border: '1px solid #fde047', fontSize: '0.72rem' }}>



                  <svg width="11" height="11" fill="none" stroke="#ca8a04" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>



                  <span style={{ color: '#78350f', flex: 1 }}>



                    HSN {hsnSuggest.hsns.join(', ')} → <b>{hsnSuggest.rate}%</b> GST



                    {!hsnSuggest.allSame && ' (mixed — picked majority)'}



                  </span>



                  <button type="button"



                    onClick={() => onTaxRateChange(hsnSuggest.rate)}



                    style={{ fontSize: '0.7rem', padding: '2px 7px', borderRadius: 4, border: '1px solid #ca8a04', background: '#fef08a', color: '#78350f', cursor: 'pointer', fontWeight: 700, whiteSpace: 'nowrap' }}>



                    Apply {hsnSuggest.rate}%



                  </button>



                </div>



              )}







              {/* Read-only GST type + editable rate */}



              {!isExport && (



                <div style={{



                  marginBottom: 8, padding: '7px 10px', borderRadius: 7,



                  background: autoInfo?.warn ? '#fffbeb' : (autoInfo?.type === 'cgst_sgst' ? '#f0fdf4' : '#eff6ff'),



                  border: `1px solid ${autoInfo?.warn ? '#fde68a' : (autoInfo?.type === 'cgst_sgst' ? '#86efac' : '#bfdbfe')}`



                }}>



                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                    <span style={{



                      fontWeight: 700, fontSize: '0.83rem', flex: 1,



                      color: autoInfo?.warn ? '#92400e' : (autoInfo?.type === 'cgst_sgst' ? '#15803d' : '#1d4ed8')



                    }}>



                      {autoInfo?.label || (form.tax_type === 'cgst_sgst' ? 'CGST + SGST' : 'IGST')}



                    </span>



                    <select className="form-control form-select"



                      style={{ fontSize: '0.78rem', padding: '2px 4px', width: 68, flexShrink: 0 }}



                      value={form.tax_rate} onChange={e => onTaxRateChange(e.target.value)}>



                      {GST_RATES.map(r => <option key={r} value={r}>{r}%</option>)}



                    </select>



                  </div>



                  <div style={{



                    fontSize: '0.7rem', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4,



                    color: autoInfo?.warn ? '#b45309' : 'var(--text-muted)'



                  }}>



                    {autoInfo?.warn



                      ? <svg width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>



                      : <svg width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>



                    }



                    {autoInfo?.reason}



                  </div>



                </div>



              )}







              {/* Export / LUT toggle */}



              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', marginBottom: isExport ? 6 : 0 }}>



                <input type="checkbox" checked={isExport}



                  onChange={e => onTaxTypeChange(e.target.checked ? 'export' : (autoInfo?.type || 'igst'))}



                  style={{ cursor: 'pointer' }} />



                <span style={{ fontSize: '0.75rem', color: isExport ? '#16a34a' : 'var(--text-muted)' }}>



                  Export / LUT (zero-rated)



                </span>



              </label>



              {isExport && (



                <div style={{ fontSize: '0.78rem', color: '#16a34a', padding: '4px 8px', background: '#f0fdf4', borderRadius: 6, border: '1px solid #86efac' }}>



                  Zero-rated supply under LUT/Bond — no GST charged



                </div>



              )}







              {/* Swift Code & Bank Address toggle — only relevant for international (non-INR) orders */}
              {form.currency !== 'INR' && (
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', marginBottom: 8 }}>
                  <input
                    type="checkbox"
                    checked={form.show_bank_details || false}
                    onChange={e => setForm(p => ({ ...p, show_bank_details: e.target.checked }))}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '0.75rem', color: form.show_bank_details ? '#2563eb' : 'var(--text-muted)' }}>
                    Show SWIFT Code & Bank Address on Invoice
                  </span>
                </label>
              )}

              {/* Tax breakdown lines */}



              {!isExport && form.tax_type === 'igst' && taxRate > 0 && (



                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.83rem', color: 'var(--text-secondary)', marginTop: 6, marginBottom: 2 }}>



                  <span>IGST @{taxRate}%</span>



                  <span>+{form.currency} {taxAmt.toFixed(2)}</span>



                </div>



              )}



              {!isExport && form.tax_type === 'cgst_sgst' && taxRate > 0 && (



                <>



                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.83rem', color: 'var(--text-secondary)', marginTop: 6, marginBottom: 2 }}>



                    <span>CGST @{(taxRate / 2).toFixed(1)}%</span>



                    <span>+{form.currency} {(taxAmt / 2).toFixed(2)}</span>



                  </div>



                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.83rem', color: 'var(--text-secondary)', marginBottom: 2 }}>



                    <span>SGST @{(taxRate / 2).toFixed(1)}%</span>



                    <span>+{form.currency} {(taxAmt / 2).toFixed(2)}</span>



                  </div>



                </>



              )}



            </>



          );



        })() : (



          <>



            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 6 }}>Tax / VAT</div>



            <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>



              <input className="form-control" style={{ fontSize: '0.75rem', padding: '3px 6px', flex: 2 }} placeholder="Tax label (e.g. VAT)" value={form.tax_label} onChange={e => setForm(p => ({ ...p, tax_label: e.target.value }))} />



              <div style={{ display: 'flex', alignItems: 'center', gap: 3, flex: 1 }}>



                <input className="form-control" type="number" min="0" max="100" step="0.5" style={{ fontSize: '0.75rem', padding: '3px 6px' }} value={form.tax_rate} onChange={e => setForm(p => ({ ...p, tax_rate: e.target.value, tax_type: Number(e.target.value) > 0 ? 'custom' : 'none' }))} />



                <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>%</span>



              </div>



            </div>



            {taxAmt > 0 && (



              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.83rem', color: 'var(--text-secondary)', marginBottom: 4 }}>



                <span>{form.tax_label || 'Tax'} @{taxRate}%</span>



                <span>+{form.currency} {taxAmt.toFixed(2)}</span>



              </div>



            )}



          </>



        )}



      </div>







      {/* Freight + Additional Charges */}



      {(freightAmt > 0 || freightGst > 0 || chargesTotal > 0) && (



        <div style={{ borderTop: '1px dashed var(--border)', paddingTop: 6, marginBottom: 6, fontSize: '0.83rem', color: 'var(--text-secondary)' }}>



          {freightAmt > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}><span>Freight</span><span>+{form.currency} {freightAmt.toFixed(2)}</span></div>}



          {freightGst > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}><span>Freight GST ({form.freight_gst_pct}%)</span><span>+{form.currency} {freightGst.toFixed(2)}</span></div>}



          {(form.charges || []).filter(c => Number(c.amount) > 0).map((c, i) => (



            <React.Fragment key={i}>



              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>



                <span>{c.label || 'Extra Charge'}</span>



                <span>+{form.currency} {Number(c.amount).toFixed(2)}</span>



              </div>



              {Number(c.gst_pct) > 0 && (



                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2, paddingLeft: 10 }}>



                  <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{c.label ? `${c.label} GST` : 'Charge GST'} ({c.gst_pct}%)</span>



                  <span style={{ fontSize: '0.78rem' }}>+{form.currency} {(Number(c.amount) * Number(c.gst_pct) / 100).toFixed(2)}</span>



                </div>



              )}



            </React.Fragment>



          ))}



        </div>



      )}







      <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: '1rem', borderTop: '1px solid var(--border)', paddingTop: 8, marginBottom: 4 }}>



        <span>Grand Total</span>



        <span style={{ color: 'var(--primary)' }}>{form.currency} {grandTotal.toFixed(2)}</span>



      </div>







      {/* Discount input */}



      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 6 }}>



        <span style={{ fontSize: '0.83rem', color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>Order Disc %</span>



        <input className="form-control" type="number" min="0" max="100" value={form.discount_percent}



          onChange={e => setForm(p => ({ ...p, discount_percent: e.target.value }))}



          style={{ width: 60, fontSize: '0.83rem', padding: '3px 6px' }} />



      </div>



      {/* Commission input for invoices and proforma invoices */}



      {['invoice', 'proforma_invoice'].includes(form.order_type) && (



        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 6 }}>



          <span style={{ fontSize: '0.83rem', color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>Commission</span>



          <input className="form-control" type="number" min="0" step="0.01" value={form.commission}



            onChange={e => setForm(p => ({ ...p, commission: e.target.value }))}



            style={{ width: 80, fontSize: '0.83rem', padding: '3px 6px' }} />



        </div>



      )}





    </div>



  );







  /* ── Render ───────────────────────────────────────────────── */



  return (



    <div className="page">



      <div className="page-header">



        <div>



          <h1 className="page-title">Orders</h1>



          <p className="page-subtitle">Manage sales orders and track delivery status</p>



        </div>



        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>



          <button className="btn btn-secondary" onClick={() => setBulkOpen({ open: true, type: 'invoice' })}>



            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>



            Upload Invoices



          </button>



          <button className="btn btn-secondary" onClick={() => setBulkOpen({ open: true, type: 'po' })}>



            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>



            Upload POs



          </button>



          <button className="btn btn-primary" onClick={openAdd}>



            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>



            New Order



          </button>



        </div>



      </div>







      {/* Filters */}



      <div className="card" style={{ marginBottom: 16 }}>



        <div className="card-body" style={{ padding: '14px 16px' }}>



          <div className="search-bar">



            <div className="search-input-wrap">



              <span className="search-icon">



                <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>



              </span>



              <input className="form-control" placeholder="Search order number or client…" value={search}



                onChange={e => { setSearch(e.target.value); setPage(1); }} />



            </div>



            <select className="form-control form-select" style={{ width: 160 }} value={statusFilter}



              onChange={e => { setStatusFilter(e.target.value); setPage(1); }}>



              <option value="">All Orders</option>



              <option value="pending">Pending</option>



              <option value="confirmed">Confirmed</option>



              <option value="processing">Processing</option>



              <option value="shipped">Shipped</option>



              <option value="delivered">Delivered</option>



              <option value="on_hold">On Hold</option>



              <option value="cancelled">Cancelled</option>



            </select>



            {(search || statusFilter) && (



              <button className="btn btn-ghost btn-sm" onClick={() => {



                const name = window.prompt('Filter name:', '');



                if (name && name.trim()) saveFilter(name.trim(), { search, statusFilter });



              }} title="Save current filter">



                Save Filter



              </button>



            )}



          </div>



          {filterPresets.length > 0 && (



            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 10 }}>



              {filterPresets.map(p => (



                <span key={p.name} style={{ background: 'var(--primary-lighter, #eff6ff)', color: 'var(--primary)', borderRadius: 20, padding: '3px 10px', fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4, border: '1px solid var(--primary-light, #bfdbfe)' }}>



                  <span onClick={() => { setSearch(p.filters.search || ''); setStatusFilter(p.filters.statusFilter || ''); setPage(1); }}>{p.name}</span>



                  <span onClick={() => removeFilter(p.name)} style={{ marginLeft: 2, opacity: 0.7, fontWeight: 700, fontSize: '0.8rem', lineHeight: 1 }}>&times;</span>



                </span>



              ))}



            </div>



          )}



        </div>



      </div>







      {/* ── Record Payment Modal ───────────────────────────────── */}



      <PaymentModal state={payModal} setState={setPayModal} onSave={handleRecordPayment} />







      {/* Toast */}



      {toast && (



        <div style={{ position: 'fixed', bottom: 24, right: 24, background: '#166534', color: '#fff', padding: '10px 20px', borderRadius: 8, zIndex: 9999, fontWeight: 600, fontSize: '0.9rem', boxShadow: '0 4px 16px rgba(0,0,0,0.18)' }}>



          {toast}



        </div>



      )}







      {/* Bulk Action Bar */}



      {selectedIds.length > 0 && isPrivileged && (



        <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: 'var(--primary-lighter, #eff6ff)', border: '1px solid var(--primary-light, #bfdbfe)', borderRadius: 8, padding: '10px 16px', marginBottom: 8 }}>



          <span style={{ fontWeight: 600, fontSize: '0.88rem', color: 'var(--primary)' }}>{selectedIds.length} selected</span>



          <select className="form-control form-select" style={{ width: 180 }} value={bulkStatus} onChange={e => setBulkStatus(e.target.value)}>



            <option value="">Change status to…</option>



            {['pending', 'confirmed', 'processing', 'shipped', 'delivered', 'cancelled', 'on_hold'].map(s => (



              <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>



            ))}



          </select>



          <button className="btn btn-primary btn-sm" onClick={handleBulkStatus} disabled={bulkApplying || !bulkStatus}>



            {bulkApplying ? 'Applying…' : 'Apply'}



          </button>



          <button className="btn btn-ghost btn-sm" onClick={() => { setSelectedIds([]); setBulkStatus(''); }}>Clear</button>



        </div>



      )}







      {/* Table */}



      <div className="card">



        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '10px 16px 0' }}>



          <div style={{ position: 'relative' }}>



            <button className="btn btn-ghost btn-sm" onClick={() => setColOpen(o => !o)} title="Toggle columns">



              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">



                <circle cx="12" cy="12" r="3" />



                <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />



              </svg>



              &nbsp;Columns



            </button>



            {colOpen && (



              <div style={{ position: 'absolute', right: 0, top: '100%', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', zIndex: 50, minWidth: 160, boxShadow: 'var(--shadow-md, 0 4px 16px rgba(0,0,0,.12))' }}>



                {COLS.map(c => (



                  <label key={c.key} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', cursor: 'pointer', fontSize: '0.82rem' }}>



                    <input type="checkbox" checked={visibleCols.includes(c.key)} onChange={() => toggleCol(c.key)} />



                    {c.label}



                  </label>



                ))}



              </div>



            )}



          </div>



        </div>



        <div className="table-container">



          <table className="table">



            <thead>



              <tr>



                {isPrivileged && (



                  <th style={{ width: 36 }}>



                    <input type="checkbox"



                      checked={data.data.length > 0 && data.data.every(o => selectedIds.includes(o.id))}



                      onChange={toggleSelectAll} />



                  </th>



                )}



                {visibleCols.includes('order_num') && <th>INVOICE #</th>}
                {actualVisibleCols.includes('client') && <th>CLIENT</th>}
                {actualVisibleCols.includes('date') && <th>DUE DATE</th>}
                {actualVisibleCols.includes('total') && <th>TOTAL</th>}
                {actualVisibleCols.includes('created_by') && <th>COMMISSION</th>}
                {actualVisibleCols.includes('status') && <th>STATUS</th>}
                {actualVisibleCols.includes('actions') && <th>ACTIONS</th>} 



              </tr> 




            </thead>



            <tbody>



              {loading && <tr><td colSpan={visibleCols.length} style={{ padding: 0 }}><SkeletonTable rows={8} cols={visibleCols.length} /></td></tr>}



              {!loading && data.data.length === 0 && <tr><td colSpan={visibleCols.length}><div className="empty-state"><p>No orders found.</p></div></td></tr>}



              {!loading && data.data.map(o => (



                <tr key={o.id} style={o.status === 'revised' ? { opacity: 0.65 } : {}}>



                  {isPrivileged && (



                    <td style={{ width: 36 }}>



                      <input type="checkbox" checked={selectedIds.includes(o.id)} onChange={() => toggleSelect(o.id)} />



                    </td>



                  )}



                  {visibleCols.includes('order_num') && (



                    <td style={{ fontWeight: 700, color: 'var(--primary)', fontSize: '0.82rem' }}>



                      {o.order_number}



                      {o.order_type === 'invoice' && (
                        o.invoice_number
                          ? <div style={{ fontSize: '0.68rem', color: '#15803d', fontWeight: 700, marginTop: 1 }}>
                              INV: {o.invoice_number}
                            </div>
                          : <div style={{ fontSize: '0.65rem', color: '#92400e', fontWeight: 600, marginTop: 1 }}>
                              Invoice pending
                            </div>
                      )}
                      {o.order_type === 'purchase_order' && o.status === 'delivered' && (
                          <div style={{ fontSize: '0.68rem', color: '#15803d', fontWeight: 700, marginTop: 1 }}>
                            {o.invoice_number ? `PO: ${o.invoice_number}` : 'Material Received'}
                          </div>
                      )}
                      {o.order_type === 'purchase_order' && o.status === 'confirmed' && (
                          <div style={{ fontSize: '0.68rem', color: '#15803d', fontWeight: 700, marginTop: 1 }}>
                            PO: {o.invoice_number || 'Generated'}
                          </div>
                      )}
                      {o.order_type === 'purchase_order' && o.status !== 'delivered' && o.status !== 'confirmed' && (
                          <div style={{ fontSize: '0.65rem', color: '#92400e', fontWeight: 600, marginTop: 1 }}>
                            PO pending
                          </div>
                      )}
                      {o.po_number && (
                        <div style={{ fontSize: '0.68rem', color: 'var(--text-secondary)', fontWeight: 600, marginTop: 1 }}>
                          {/* Ref PO: {o.po_number} */}
                        </div>
                      )}



                      {o.revised_from_id && <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginTop: 1 }}>revision</div>}



                      {o.parent_order_id && <div style={{ fontSize: '0.65rem', color: '#92400e', fontWeight: 600, marginTop: 1 }}>↳ split from {o.parent_order_number}</div>}



                      {Number(o.split_count) > 0 && <div style={{ fontSize: '0.65rem', color: '#0369a1', fontWeight: 600, marginTop: 1 }}>{o.split_count} split{o.split_count > 1 ? 's' : ''}</div>}



                      <div style={{ display: 'flex', gap: 3, marginTop: 2, flexWrap: 'wrap' }}>



                        {o.irn_status === 'generated' && (



                          <span style={{ fontSize: '0.6rem', fontWeight: 700, padding: '1px 5px', borderRadius: 8, background: '#dcfce7', color: '#15803d', border: '1px solid #86efac' }}>e-Invoice ✓</span>



                        )}



                        {o.ewb_status === 'active' && (



                          <span style={{ fontSize: '0.6rem', fontWeight: 700, padding: '1px 5px', borderRadius: 8, background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' }}>EWB</span>



                        )}



                      </div>



                    </td>



                  )}



                  {actualVisibleCols.includes('client') && (

                    <td>

                      <div style={{ fontWeight: 600 }}>{o.client_name}</div>

                      <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{o.client_country || ''}</div>

                    </td>

                  )}

                  {actualVisibleCols.includes('date') && (

                    <td style={{ color: o.due_date ? 'var(--text-secondary)' : 'var(--text-muted)', fontSize: '0.8rem', fontWeight: o.due_date ? 500 : 400 }}>

                      {o.due_date
                        ? new Date(o.due_date.split('T')[0] + 'T00:00:00').toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
                        : '—'}

                    </td>

                  )}

                  {actualVisibleCols.includes('total') && (
                    <td style={{ fontWeight: 700 }}>
                      <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{o.currency} </span>
                      {(() => {
                        const net = Number(o.total || 0);
                        const taxAmt = net * Number(o.tax_rate || 0) / 100;
                        const freight = Number(o.freight_amount || 0);
                        const freightGst = freight * Number(o.freight_gst_pct || 0) / 100;
                        const charges = Number(o.other_charges || 0);
                        return (net + taxAmt + freight + freightGst + charges).toFixed(2);
                      })()}
                    </td>
                  )}
                  {actualVisibleCols.includes('total') && (
                    <td style={{ fontWeight: 600, color: o.order_type === 'invoice' ? '#f59e0b' : 'var(--text-secondary)' }}>
                      {o.order_type === 'invoice' ? (
                        <>
                          <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{o.currency} </span>
                          {Number(o.commission || 0).toFixed(2)}
                        </>
                      ) : (
                        <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>Pending</span>
                      )}
                    </td>
                  )}

                  {actualVisibleCols.includes('status') && (

                    <td>

                      <span className={`badge badge-${statusColors[o.status] || 'neutral'}`} style={{ textTransform: 'capitalize' }}>

                        {o.status}

                      </span>

                    </td>

                  )}



                  {visibleCols.includes('actions') && (



                    <td>



                      <div className="table-actions">



                        <button className="btn btn-ghost btn-icon" data-tooltip="View" onClick={() => openView(o)}>



                          <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>



                        </button>



                        {/* Edit — pending only */}



                        {o.status === 'pending' && (isPrivileged || o.user_id === user?.id) && (



                          <button className="btn btn-ghost btn-icon" data-tooltip="Edit Order" onClick={() => openEdit(o)}>



                            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>



                          </button>



                        )}



                        {/* Revise — confirmed only */}



                        {o.status === 'confirmed' && (isPrivileged || o.user_id === user?.id) && (



                          <button className="btn btn-ghost btn-icon"
                            data-tooltip={revisingId === o.id ? 'Revision in progress…' : 'Revise Order'}
                            style={{ color: 'var(--warning, #f59e0b)' }}
                            disabled={revisingId === o.id}
                            onClick={() => handleRevise(o)}>
                            {revisingId === o.id
                              ? <span style={{ width: 15, height: 15, border: '2px solid var(--warning, #f59e0b)', borderTopColor: 'transparent', borderRadius: '50%', display: 'inline-block', animation: 'spin 0.7s linear infinite' }} />
                              : <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 102.13-9.36L1 10" /></svg>
                            }
                          </button>



                        )}



                        {/* Status update — not for revised/delivered/cancelled */}



                        {!['delivered', 'cancelled', 'revised'].includes(o.status) && (isPrivileged || o.user_id === user?.id) && (



                          <button className="btn btn-ghost btn-icon" data-tooltip="Update Status"



                            onClick={() => setStatusModal({ open: true, order: o, status: '' })}>



                            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" /></svg>



                          </button>



                        )}



                        {/* Clone order — shown only when enabled in Company Settings */}



                        {companySettings?.enableCloneOrder && (



                          <button className="btn btn-ghost btn-icon" data-tooltip="Clone Order" onClick={() => handleClone(o)}>



                            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" /></svg>



                          </button>



                        )}



                        {/* Split */}



                        {companySettings?.enableSplitOrder && (isPrivileged || o.user_id === user?.id) && (



                          <button className="btn btn-ghost btn-icon" data-tooltip="Split into New Order"



                            style={{ color: 'var(--warning, #f59e0b)' }}



                            onClick={async () => { const { data: r } = await api.get(`/orders/${o.id}`); openSplitModal(r.data); }}>



                            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="3" x2="12" y2="21" /><polyline points="7 8 12 3 17 8" /><polyline points="7 16 12 21 17 16" /></svg>



                          </button>



                        )}



                        {/* Assignments */}



                        <button className="btn btn-ghost btn-icon" data-tooltip="Assignments & Work Logs"



                          style={{ color: 'var(--primary)' }}



                          onClick={() => openAssignModal(o)}>



                          <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" /></svg>



                        </button>



                      </div>



                    </td>



                  )}



                </tr>



              ))}



            </tbody>



          </table>



        </div>



        <Pagination page={data.page} total={data.total} limit={data.limit} onPageChange={setPage} />



      </div>

      {/* ── Create / Edit Order Modal ──────────────────────────── */}

      <Modal open={modal.open} onClose={() => setModal({ open: false, mode: 'add', editId: null })}



        title={modal.mode === 'edit' ? 'Edit Order (Pending)' : 'Create New Order'} size="xl"



        footer={<>



          <button className="btn btn-secondary" onClick={() => setModal({ open: false, mode: 'add', editId: null })}>Cancel</button>



          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>



            {saving ? (modal.mode === 'edit' ? 'Saving…' : 'Creating…') : (modal.mode === 'edit' ? 'Save Changes' : 'Create Order')}



          </button>



        </>}



      >



        <div>



          {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}




          {/* Credit limit warning */}



          {(() => {



            const key = form.party_type === 'client'



              ? `client-${form.client_id}`



              : `customer-${form.customer_id}`;



            const credit = (form.client_id || form.customer_id) ? creditMap[key] : null;



            if (!credit || Number(credit.credit_limit || 0) <= 0) return null;



            const creditLimit = Number(credit.credit_limit || 0);



            const outstanding = Number(credit.outstanding || 0);



            // Warn if already exceeded OR if this order's total would push over the limit



            const projectedTotal = outstanding + grandTotal;



            const alreadyExceeded = outstanding >= creditLimit;



            const wouldExceed = !alreadyExceeded && grandTotal > 0 && projectedTotal > creditLimit;



            if (alreadyExceeded || wouldExceed) {



              const fmtOutstanding = outstanding.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });



              const fmtLimit = creditLimit.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });



              const fmtProjected = projectedTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });



              return (



                <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '10px 14px', marginBottom: 14, color: '#991b1b', fontSize: '0.88rem', fontWeight: 500 }}>



                  ⚠️ Credit limit warning: {alreadyExceeded



                    ? `This ${form.party_type} already has ₹${fmtOutstanding} outstanding against a ₹${fmtLimit} credit limit.`



                    : `This order (₹${grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}) would bring the projected outstanding to ₹${fmtProjected}, exceeding the ₹${fmtLimit} credit limit.`}



                </div>



              );



            }



            return null;



          })()}







          {/* Party type toggle */}



          <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>



            {['client', 'customer'].map(pt => (



              <button key={pt} type="button"



                className={`btn btn-sm ${form.party_type === pt ? 'btn-primary' : 'btn-secondary'}`}



                style={{ textTransform: 'capitalize', flex: 1 }}



                onClick={() => { setForm(p => ({ ...p, party_type: pt, client_id: '', customer_id: '', contact_id: '' })); setEntityContacts([]); }}>



                {pt === 'client' ? 'Pharma Client' : 'Customer (Doctor/Hospital…)'}



              </button>



            ))}



          </div>







          <div className="form-row">



            <div className="form-group">



              {form.party_type === 'client' ? (



                <>



                  <label className="form-label">Client *</label>



                  <TypeaheadSelect



                    value={form.client_id}



                    options={clients.map(c => ({



                      value: c.id,



                      label: c.name,



                      sub: [c.type ? c.type.replace(/_/g, ' ') : null, c.country].filter(Boolean).join(' · '),



                    }))}



                    placeholder="Type to search client…"



                    onChange={id => {



                      const client = clients.find(c => String(c.id) === String(id));



                      const partyData = autoFillParty(client);



                      const taxDefaults = getTaxDefaults(form.currency, partyData.client_state_code, form.tax_rate);



                      setForm(p => ({ ...p, client_id: id, contact_id: '', ...partyData, ...taxDefaults }));



                      loadEntityAddresses('client', id);



                      loadEntityContacts('client', id);



                    }}



                  />



                </>



              ) : (



                <>



                  <label className="form-label">Customer *</label>



                  <TypeaheadSelect



                    value={form.customer_id}



                    options={customers.map(c => ({



                      value: c.id,



                      label: c.name,



                      sub: [c.type ? c.type.charAt(0).toUpperCase() + c.type.slice(1) : null, c.city].filter(Boolean).join(' · '),



                    }))}



                    placeholder="Type to search customer…"



                    onChange={id => {



                      const cust = customers.find(c => String(c.id) === String(id));



                      const partyData = autoFillParty(cust);



                      const taxDefaults = getTaxDefaults(form.currency, partyData.client_state_code, form.tax_rate);



                      setForm(p => ({ ...p, customer_id: id, ...partyData, ...taxDefaults }));



                      loadEntityAddresses('customer', id);



                    }}



                  />



                </>



              )}



            </div>







            {/* Contact Person — only shown for clients that have contacts */}



            {form.party_type === 'client' && form.client_id && (



              <div className="form-group">



                <label className="form-label">Contact Person</label>



                {entityContacts.length > 0 ? (



                  <select



                    className="form-control form-select"



                    value={form.contact_id}



                    onChange={e => setForm(p => ({ ...p, contact_id: e.target.value }))}



                  >



                    <option value="">— Select contact (optional) —</option>



                    {entityContacts.map(c => (



                      <option key={c.id} value={c.id}>



                        {c.name}{c.designation ? ` · ${c.designation}` : ''}{c.department ? ` (${c.department})` : ''}



                      </option>



                    ))}



                  </select>



                ) : (



                  <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', padding: '7px 0' }}>



                    No contacts added for this client. Add them in the Clients page.



                  </div>



                )}



              </div>



            )}







            <div className="form-group">



              <label className="form-label">Order Type</label>



              <select className="form-control form-select" value={form.order_type}



                onChange={e => setForm(p => ({ ...p, order_type: e.target.value }))}>



                {ORDER_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}



              </select>



            </div>



          </div>







          {/* ── Billing & Shipping Addresses ── */}



          <AddressFields



            billingValue={form.billing_address}



            shippingValue={form.shipping_address}



            savedAddresses={savedAddresses}



            onBillingChange={v => setForm(p => ({ ...p, billing_address: v }))}



            onShippingChange={v => setForm(p => ({ ...p, shipping_address: v }))}



            onSameAsBilling={() => setForm(p => ({ ...p, shipping_address: p.billing_address }))}



          />







          <div style={{ marginBottom: 14 }}>



            <PODocumentParser



              disabled={saving}



              onApply={(fields) => {



                setForm(prev => ({



                  ...prev,



                  po_number: fields.po_number || prev.po_number,



                  po_date: fields.po_date || prev.po_date,



                  notes: fields.buyer_name ? `Buyer: ${fields.buyer_name}${prev.notes ? '\n' + prev.notes : ''}` : prev.notes,



                }));



              }}



            />



          </div>







          <div className="form-row">



            <div className="form-group">



              <label className="form-label">Currency</label>



              <select className="form-control form-select" value={form.currency}



                onChange={e => onCurrencyChange(e.target.value)}>



                {CURRENCIES.map(c => <option key={c} value={c}>{c}</option>)}



              </select>



            </div>



            <div className="form-group">



              <label className="form-label">PO / Ref Number</label>



              <input className="form-control" placeholder="e.g. SUN-PO-2025-001" value={form.po_number}



                onChange={e => setForm(p => ({ ...p, po_number: e.target.value }))} />



            </div>



            <div className="form-group">



              <label className="form-label">PO Date</label>



              <input className="form-control" type="date" value={form.po_date}



                onChange={e => setForm(p => ({ ...p, po_date: e.target.value }))} />



            </div>



            {/* <div className="form-group">



              <label className="form-label">Expected Delivery</label>



              <input className="form-control" type="date" value={form.expected_delivery}



                onChange={e => setForm(p => ({ ...p, expected_delivery: e.target.value }))} />



            </div> */}



            <div className="form-group">
              <label className="form-label">Payment Term</label>



              <select className="form-control" value={form.payment_term || ''}
                onChange={(e) => setForm(p => ({ ...p, payment_term: e.target.value }))}>
                <option value="">Select Payment Term</option>
                <option value="Advance">1. Advance</option>
                <option value="30 days">2. 30 days</option>
                <option value="15 days">3. 15 days</option>
                <option value="30 days PDC">4. 30 days PDC</option>
                <option value="45 days">5. 45 days</option>
                <option value="45 days PDC">6. 45 days PDC</option>
                <option value="50% Advance">7. 50% Advance</option>
                <option value="50% Against Delivery">8. 50% Against Delivery</option>
              </select>



            </div>

            {form.order_type === 'proforma_invoice' && (
              <div className="form-group">
                <label className="form-label">Due Date</label>
                <input
                  className="form-control"
                  type="date"
                  value={form.due_date}
                  onChange={e => setForm(p => ({ ...p, due_date: e.target.value }))}
                />
              </div>
            )}






          </div>



          <details style={{ marginBottom: 14 }}>



            <summary style={{ cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem', color: 'var(--text-secondary)', padding: '6px 0', userSelect: 'none' }}>



              PO / Invoice Details (optional - used on PDF)



            </summary>



            <div style={{ paddingTop: 12 }}>



              <div className="form-row">



                <div className="form-group">



                  <label className="form-label">Quote / Ref Number</label>



                  <input className="form-control" placeholder="e.g. QUO-2025-042" value={form.quote_number}



                    onChange={e => setForm(p => ({ ...p, quote_number: e.target.value }))} />



                </div>



                <div className="form-group">



                  <label className="form-label">Quote Date</label>



                  <input className="form-control" type="date" value={form.quote_date}



                    onChange={e => setForm(p => ({ ...p, quote_date: e.target.value }))} />



                </div>



              </div>



              <div className="form-row">



                <div className="form-group">



                  <label className="form-label">Client GSTIN</label>



                  <input className="form-control" placeholder="e.g. 27AABCU9603R1ZX" value={form.client_gstin}



                    onChange={e => {



                      const gstin = e.target.value;



                      const sc = /^\d{2}/.test(gstin) ? gstin.substring(0, 2) : form.client_state_code;



                      const taxDefaults = getTaxDefaults(form.currency, sc, form.tax_rate);



                      setForm(p => ({ ...p, client_gstin: gstin, client_state_code: sc, ...taxDefaults }));



                    }} />



                </div>



                <div className="form-group">



                  <label className="form-label">Client State</label>



                  <select className="form-control" value={form.client_state_code}



                    onChange={e => {



                      const sc = e.target.value;



                      const taxDefaults = getTaxDefaults(form.currency, sc, form.tax_rate);



                      setForm(p => ({ ...p, client_state_code: sc, ...taxDefaults }));



                    }}>



                    <option value="">— Select State —</option>



                    {INDIAN_STATES.map(s => (



                      <option key={s.code} value={s.code}>{s.code} — {s.name}</option>



                    ))}



                  </select>



                </div>



                <div className="form-group">



                  <label className="form-label">Client Phone</label>



                  <input className="form-control" placeholder="e.g. +91-9876543210" value={form.client_phone}



                    onChange={e => setForm(p => ({ ...p, client_phone: e.target.value }))} />



                </div>



              </div>



              {form.order_type === 'invoice' && (



                <div className="form-row">



                  {/* <div className="form-group">



                    <label className="form-label">Waybill / AWB Number</label>



                    <input className="form-control" placeholder="e.g. DHL123456789" value={form.waybill_number}



                      onChange={e => setForm(p => ({ ...p, waybill_number: e.target.value }))} />



                  </div>



                  <div className="form-group">



                    <label className="form-label">Waybill Date</label>



                    <input className="form-control" type="date" value={form.waybill_date}



                      onChange={e => setForm(p => ({ ...p, waybill_date: e.target.value }))} />



                  </div> */}



                </div>



              )}



              <div className="form-row">



                <div className="form-group">



                  <label className="form-label">Freight Amount</label>



                  <input className="form-control" type="number" min="0" step="0.01" value={form.freight_amount}



                    onChange={e => setForm(p => ({ ...p, freight_amount: e.target.value }))} />



                </div>



                <div className="form-group">



                  <label className="form-label">Freight GST %</label>



                  <input className="form-control" type="number" min="0" max="28" step="0.5" value={form.freight_gst_pct}



                    onChange={e => setForm(p => ({ ...p, freight_gst_pct: e.target.value }))} />



                </div>



                <div className="form-group">



                  <label className="form-label">Freight Detail</label>



                  <input className="form-control" placeholder="e.g. At our Cost" value={form.freight_detail}



                    onChange={e => setForm(p => ({ ...p, freight_detail: e.target.value }))} />



                </div>



              </div>



              <div className="form-row">



                <div className="form-group">



                  <label className="form-label">Destination</label>



                  <input className="form-control" placeholder="e.g. Mumbai, Maharashtra" value={form.destination}



                    onChange={e => setForm(p => ({ ...p, destination: e.target.value }))} />



                </div>



                <div className="form-group">



                  <label className="form-label">Terms of Delivery</label>



                  <input className="form-control" placeholder="e.g. Door Delivery, Ex-Works, CIF, FOB…" value={form.terms_of_delivery}



                    onChange={e => setForm(p => ({ ...p, terms_of_delivery: e.target.value }))} />



                </div>



              </div>



              <div className="form-group">



                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>



                  <label className="form-label" style={{ marginBottom: 0 }}>Additional Charges</label>



                  <button type="button" className="btn btn-ghost btn-sm"



                    onClick={() => setForm(p => ({ ...p, charges: [...(p.charges || []), { label: '', amount: '', gst_pct: 18 }] }))}>



                    + Add Charge



                  </button>



                </div>



                {(form.charges || []).length === 0 && (



                  <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>No additional charges. Click "+ Add Charge" to add packing, insurance, etc.</div>



                )}



                {(form.charges || []).map((ch, ci) => (



                  <div key={ci} style={{ display: 'flex', gap: 8, marginBottom: 6, alignItems: 'center' }}>



                    <input className="form-control" placeholder="Label (e.g. Packing)" style={{ flex: 2, fontSize: '0.83rem' }}



                      value={ch.label} onChange={e => setForm(p => { const c = [...p.charges]; c[ci] = { ...c[ci], label: e.target.value }; return { ...p, charges: c }; })} />



                    <input className="form-control" type="number" min="0" step="0.01" placeholder="Amount" style={{ flex: 1, fontSize: '0.83rem' }}



                      value={ch.amount} onChange={e => setForm(p => { const c = [...p.charges]; c[ci] = { ...c[ci], amount: e.target.value }; return { ...p, charges: c }; })} />



                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>



                      <select className="form-control" style={{ width: 72, fontSize: '0.8rem', padding: '3px 4px' }}



                        value={ch.gst_pct !== undefined ? ch.gst_pct : 18}



                        onChange={e => setForm(p => { const c = [...p.charges]; c[ci] = { ...c[ci], gst_pct: Number(e.target.value) }; return { ...p, charges: c }; })}>



                        {GST_RATES.map(r => <option key={r} value={r}>{r}% GST</option>)}



                      </select>



                    </div>



                    <button type="button" className="btn btn-ghost btn-icon btn-sm" style={{ color: 'var(--error)' }}



                      onClick={() => setForm(p => ({ ...p, charges: p.charges.filter((_, idx) => idx !== ci) }))}>×</button>



                  </div>



                ))}



              </div>



              <div className="form-group">



                <label className="form-label">Additional Information</label>



                <input className="form-control" placeholder="e.g. delivery instructions, special notes…" value={form.additional_info}



                  onChange={e => setForm(p => ({ ...p, additional_info: e.target.value }))} />



              </div>



            </div>



          </details>







          {/* Line items */}



          <div style={{ marginBottom: 14 }}>



            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>



              <label className="form-label" style={{ marginBottom: 0 }}>Order Items *</label>



              <button className="btn btn-secondary btn-sm" onClick={addItem}>+ Add Item</button>



            </div>



            <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflowX: 'auto', maxWidth: '100%' }}>



              <table className="table" style={{ marginBottom: 0, minWidth: '100%' }}>



                <thead>



                  <tr>



                    <th style={{ minWidth: 400 }}>Catalog Item</th>



                    <th style={{ minWidth: 130 }}>HSN Code</th>



                    <th style={{ minWidth: 140 }}>Pack Size</th>



                    <th style={{ minWidth: 150 }}>Batch No.</th>
                    {form.order_type === 'purchase_order' && <th style={{ minWidth: 155 }}>Vendor Cat No.</th>}






                    <th style={{ minWidth: 100 }}>Qty</th>



                    <th style={{ minWidth: 130 }}>Unit Price</th>



                    <th style={{ minWidth: 100 }}>Disc%</th>



                    <th style={{ minWidth: 120 }}>Line Total</th>



                    <th style={{ width: 36 }}></th>



                  </tr>



                </thead>



                <tbody>



                  {form.items.map((it, i) => {



                    const lineTotal = calcLine(it);



                    const cat = catalogItems.find(c => c.id === Number(it.catalog_item_id));







                    return (



                      <tr key={i}>



                        <td>



                          <CatalogCombobox


                            catalogItems={catalogItems}


                            value={it.catalog_item_id}


                            onSelect={id => handleItemCatalogChange(i, id)}


                            canAddNew={true}


                            onAddNew={() => handleItemCatalogChange(i, '__new__')}


                            style={{ width: '100%', minWidth: 400 }}


                          />



                          {cat && cat.stock_quantity !== null && cat.stock_quantity !== undefined && (



                            cat.stock_quantity <= 0



                              ? <div style={{ fontSize: '0.75rem', color: '#dc2626', marginTop: 2, display: 'flex', alignItems: 'center', gap: 3 }}>



                                <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>



                                Out of stock



                              </div>



                              : cat.min_stock_alert !== null && cat.stock_quantity <= cat.min_stock_alert



                                ? <div style={{ fontSize: '0.75rem', color: '#d97706', marginTop: 2, display: 'flex', alignItems: 'center', gap: 3 }}>



                                  <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>



                                  Low stock ({cat.stock_quantity} left)



                                </div>



                                : null



                          )}



                        </td>



                        <td>
                          <input
                            className="form-control"
                            style={{ fontSize: '0.82rem' }}
                            placeholder="HSN Code"
                            value={it.hsn_code || ''}
                            onChange={e => setItem(i, 'hsn_code', e.target.value)}
                            title="Pre-filled from catalog — editable"
                          />
                        </td>

                        <td>
                          <input className="form-control" style={{ fontSize: '0.82rem' }} placeholder="e.g. 10mg"


                            value={it.pack_size}



                            onChange={e => setItem(i, 'pack_size', e.target.value)} />
                        </td>
                        <td>
                          <input className="form-control" style={{ fontSize: '0.82rem' }} placeholder="e.g. PL-2025-001"
                            value={it.batch_number}
                            onChange={e => setItem(i, 'batch_number', e.target.value)} />
                        </td>
                        {form.order_type === 'purchase_order' && (
                          <td>
                            <input className="form-control" style={{ fontSize: '0.82rem' }} placeholder="e.g. CAT-001"
                              value={it.catalog_number || ''}
                              onChange={e => setItem(i, 'catalog_number', e.target.value)} />
                          </td>
                        )}

                        <td>


                          <input className="form-control" style={{ fontSize: '0.82rem' }} type="number" min="1"



                            value={it.quantity}



                            onChange={e => setItem(i, 'quantity', e.target.value)} />



                        </td>



                        <td>



                          <input className="form-control" style={{ fontSize: '0.82rem' }} type="number" min="0" step="0.01"



                            value={it.price}



                            onChange={e => setItem(i, 'price', e.target.value)} />



                        </td>



                        <td>



                          <input className="form-control" style={{ fontSize: '0.9rem', fontWeight: '500', backgroundColor: '#f8fafc' }} type="number" min="0" max="100"



                            value={it.discount_percent}



                            onChange={e => setItem(i, 'discount_percent', e.target.value)} />



                        </td>



                        <td style={{ fontWeight: 600, fontSize: '0.83rem', textAlign: 'right' }}>



                          {Number(lineTotal).toFixed(2)}



                        </td>



                        <td>



                          {form.items.length > 1 && (



                            <button className="btn btn-ghost btn-icon" style={{ color: 'var(--error)' }} onClick={() => removeItem(i)}>×</button>



                          )}



                        </td>



                      </tr>



                    );



                  })}



                </tbody>



              </table>



            </div>



          </div>







          {/* Notes + Tax Panel */}



          <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>



            <div className="form-group" style={{ flex: 1 }}>



              <label className="form-label">Notes</label>



              <textarea className="form-control" rows={2} value={form.notes}



                onChange={e => setForm(p => ({ ...p, notes: e.target.value }))} />



            </div>



            <TaxPanel />



          </div>

        </div>
      </Modal>







      {/* ── New Product Inline Modal ────────────────────────────── */}



      {newProdModal.open && (



        <div className="modal-overlay" onClick={() => setNewProdModal({ open: false, itemIndex: null })}>



          <div className="modal" style={{ width: 560, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>



            <div className="modal-header">



              <h3 className="modal-title">Add New Product to Catalog</h3>



              <button className="modal-close" onClick={() => setNewProdModal({ open: false, itemIndex: null })}>×</button>



            </div>



            <div className="modal-body">



              {newProdError && <div className="alert alert-error" style={{ marginBottom: 14 }}>{newProdError}</div>}



              <div className="form-row">



                <div className="form-group" style={{ flex: 2 }}>



                  <label className="form-label">Product Name *</label>



                  <input className="form-control" value={newProdForm.name}



                    onChange={e => setNewProdForm(p => ({ ...p, name: e.target.value }))}



                    placeholder="e.g. Atorvastatin Impurity A" autoFocus />



                </div>



              </div>



              <div className="form-row">



                <div className="form-group">



                  <label className="form-label">Category *</label>



                  <select className="form-control" value={newProdForm.category}



                    onChange={e => setNewProdForm(p => ({ ...p, category: e.target.value }))}>



                    {CATALOG_CATEGORIES.map(c => <option key={c} value={c}>{catLbl(c)}</option>)}



                  </select>



                </div>



                <div className="form-group">



                  <label className="form-label">Pharmacopeia</label>



                  <select className="form-control" value={newProdForm.pharmacopeia}



                    onChange={e => setNewProdForm(p => ({ ...p, pharmacopeia: e.target.value }))}>



                    {PHARMACOPEIAS.map(ph => <option key={ph} value={ph}>{ph}</option>)}



                  </select>



                </div>



              </div>



              <div className="form-row">



                <div className="form-group" style={{ flex: 1 }}>



                  <label className="form-label">CAS Number</label>



                  <input className="form-control" value={newProdForm.cas_number}



                    onChange={e => setNewProdForm(p => ({ ...p, cas_number: e.target.value }))}



                    placeholder="e.g. 1234-56-7" />



                </div>



                <div className="form-group" style={{ flex: 1 }}>



                  <label className="form-label">HSN Code</label>



                  <input className="form-control" value={newProdForm.hsn_code}



                    onChange={e => setNewProdForm(p => ({ ...p, hsn_code: e.target.value }))}



                    placeholder="e.g. 29420090" />



                </div>



                <div className="form-group" style={{ flex: 1 }}>



                  <label className="form-label">Unit Price ({companyCurrency})</label>



                  <input className="form-control" type="number" min="0" step="0.01"



                    value={newProdForm.price}



                    onChange={e => setNewProdForm(p => ({ ...p, price: e.target.value }))}



                    placeholder="0.00" />



                </div>



              </div>



              <div className="form-group">



                <label className="form-label">Pack Sizes <span style={{ fontWeight: 400, color: 'var(--text-muted)' }}>(comma-separated, e.g. 5mg, 10mg, 25mg)</span></label>



                <input className="form-control" value={newProdForm.pack_sizes}



                  onChange={e => setNewProdForm(p => ({ ...p, pack_sizes: e.target.value }))}



                  placeholder="5mg, 10mg, 25mg" />



              </div>



              <div className="form-group">



                <label className="form-label">Description</label>



                <textarea className="form-control" rows={2} value={newProdForm.description}



                  onChange={e => setNewProdForm(p => ({ ...p, description: e.target.value }))} />



              </div>



              <div style={{ marginBottom: 8 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none', fontWeight: 500, fontSize: '0.875rem' }}>
                  <input type="checkbox" checked={!!newProdForm.prasi_lab_catalog} onChange={e => setNewProdForm(p => ({ ...p, prasi_lab_catalog: e.target.checked }))} style={{ width: 16, height: 16 }} />
                  PrasiLab Catalog <span style={{ fontWeight: 400, fontSize: '0.8rem', color: 'var(--text-muted)' }}>(made by us; uncheck if vendor product)</span>
                </label>
              </div>

              <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4 }}>



                This product will be added to the catalog and selected on this line item.



              </p>



            </div>



            <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '12px 20px', borderTop: '1px solid var(--border)' }}>



              <button className="btn btn-secondary" onClick={() => setNewProdModal({ open: false, itemIndex: null })}>Cancel</button>



              <button className="btn btn-primary" onClick={handleSaveNewProduct} disabled={newProdSaving}>



                {newProdSaving ? 'Saving…' : 'Create & Select'}



              </button>



            </div>



          </div>



        </div>



      )}







      {/* ── View Order Modal ───────────────────────────────────── */}



      <Modal open={viewModal.open} onClose={() => setViewModal({ open: false })} title="Order Details" size="lg"



        footer={



          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, width: '100%', alignItems: 'center' }}>



            {/* ── Left: WhatsApp actions ── */}



            {viewModal.order && (



              <div style={{ display: 'flex', gap: 0, marginRight: 'auto' }}>



                <button className="btn btn-secondary" style={{ background: '#25d366', color: '#fff', border: 'none', borderRadius: '7px 0 0 7px', padding: '6px 10px', fontSize: '0.8rem' }}



                  title="Share order summary via WhatsApp"



                  onClick={() => {



                    const o = viewModal.order;



                    const items = (o.items || []).map(it => `  \u2022 ${it.item_name || it.catalog_number} \u00d7 ${it.quantity} @ ${o.currency} ${Number(it.price).toFixed(2)}`).join('\n');



                    const typeLabel = { invoice: 'Tax Invoice', proforma_invoice: 'Proforma Invoice', purchase_order: 'Purchase Order' }[o.order_type] || o.order_type;



                    const msg = `*${typeLabel}: ${o.order_number}*\nClient: ${o.client_name || ''}\nDate: ${new Date(o.created_at || o.order_created_at).toLocaleDateString('en-IN')}\n\n*Items:*\n${items}\n\n*Total: ${o.currency} ${Number(o.total).toFixed(2)}*\nStatus: ${o.status}${o.notes ? `\n\nNote: ${o.notes}` : ''}`;



                    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');



                  }}>



                  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 4, verticalAlign: 'middle' }}>



                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />



                  </svg>



                  Share



                </button>



                <button



                  className="btn btn-secondary"



                  style={{ background: '#128c50', color: '#fff', border: 'none', borderRadius: '0 7px 7px 0', padding: '6px 10px', fontSize: '0.8rem', borderLeft: '1px solid #0f7a45' }}



                  title="Send via PRASI LABS CRM WhatsApp API"



                  disabled={whatsappSending}



                  onClick={() => handleSendWhatsapp(viewModal.order.id)}



                >



                  {whatsappSending



                    ? <><div className="spinner" style={{ width: 11, height: 11, display: 'inline-block', marginRight: 3 }} />Sending…</>



                    : <><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ marginRight: 3, verticalAlign: 'middle' }}><line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" /></svg>Send</>



                  }



                </button>



              </div>



            )}







            {/* ── Right: document downloads ── */}



            {viewModal.order?.order_type === 'purchase_order' && (



              <button className="btn btn-secondary" style={{ fontSize: '0.8rem', padding: '6px 10px' }}
                disabled={viewModal.order?.status === 'pending'}
                title={viewModal.order?.status === 'pending' ? 'PO number is assigned on confirmation' : 'Download PO PDF'}
                onClick={async () => {



                const { data: r } = await api.get(`/orders/${viewModal.order.id}`);



                generatePurchaseOrderPDF(r.data);



              }}>



                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: 4, verticalAlign: 'middle' }}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>



                PO PDF



              </button>



            )}



            {viewModal.order?.order_type === 'invoice' && (



              <button className="btn btn-secondary" style={{ fontSize: '0.8rem', padding: '6px 10px' }} onClick={async () => {



                const { data: r } = await api.get(`/orders/${viewModal.order.id}`);



                generateInvoicePDF(r.data);



              }}>



                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: 4, verticalAlign: 'middle' }}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>



                Invoice PDF



              </button>



            )}



            {viewModal.order?.order_type === 'proforma_invoice' && (



              <button className="btn btn-secondary" style={{ fontSize: '0.8rem', padding: '6px 10px' }} onClick={async () => {



                const { data: r } = await api.get(`/orders/${viewModal.order.id}`);



                generateProformaInvoicePDF(r.data);



              }}>



                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: 4, verticalAlign: 'middle' }}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>



                Proforma PDF



              </button>



            )}



            {viewModal.order?.order_type === 'invoice' && isPrivileged && (



              <button className="btn btn-secondary" style={{ fontSize: '0.8rem', padding: '6px 10px' }}



                onClick={() => handleGenerateProforma(viewModal.order.id)}



                disabled={genProformaLoading}



                title="Generate a Proforma Invoice from this Tax Invoice"



              >



                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: 4, verticalAlign: 'middle' }}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="12" y1="18" x2="12" y2="12" /><line x1="9" y1="15" x2="15" y2="15" /></svg>



                {genProformaLoading ? 'Generating…' : 'Gen Proforma'}



              </button>



            )}







            {/* ── Right: order actions ── */}



            {companySettings?.enableSplitOrder && viewModal.order && (isPrivileged || viewModal.order.user_id === user?.id) && (



              <button className="btn btn-secondary" style={{ fontSize: '0.8rem', padding: '6px 10px', borderColor: '#f59e0b', color: '#92400e' }}



                onClick={() => openSplitModal(viewModal.order)}>



                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: 4, verticalAlign: 'middle' }}><line x1="12" y1="3" x2="12" y2="21" /><polyline points="7 8 12 3 17 8" /><polyline points="7 16 12 21 17 16" /></svg>



                Split



              </button>



            )}



            {viewModal.order?.order_type === 'invoice' && !['cancelled', 'delivered'].includes(viewModal.order?.status) && (



              <button className="btn btn-primary" style={{ fontSize: '0.8rem', padding: '6px 10px' }} onClick={() => { setViewModal({ open: false }); openPayModal(viewModal.order); }}>



                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: 4, verticalAlign: 'middle' }}><rect x="2" y="5" width="20" height="14" rx="2" /><line x1="2" y1="10" x2="22" y2="10" /></svg>



                Record Payment



              </button>



            )}



            <button className="btn btn-secondary" style={{ fontSize: '0.8rem', padding: '6px 12px' }} onClick={() => setViewModal({ open: false })}>Close</button>



          </div>



        }



      >



        {viewModal.order && (() => {



          const o = viewModal.order;



          // Compute tax for view



          const netAmt = Number(o.subtotal || 0) - Number(o.discount_amount || 0);



          const tRate = (o.tax_type === 'export' || o.tax_type === 'none') ? 0 : (Number(o.tax_rate) || 0);



          const tAmt = netAmt * tRate / 100;



          const fAmt = Number(o.freight_amount || 0);



          const fGst = fAmt * Number(o.freight_gst_pct || 0) / 100;



          const ordCharges = Array.isArray(o.charges) && o.charges.length > 0 ? o.charges : (Number(o.other_charges) > 0 ? [{ label: 'Other Charges', amount: Number(o.other_charges), gst_pct: 0 }] : []);



          const oChrg = ordCharges.reduce((s, c) => s + (Number(c.amount) || 0), 0);



          const oChrgGst = ordCharges.reduce((s, c) => s + (Number(c.amount) || 0) * (Number(c.gst_pct) || 0) / 100, 0);



          const gTotal = netAmt + tAmt + fAmt + fGst + oChrg + oChrgGst;



          // ── Journey view helpers ────────────────────────────────────────────



          const STATUS_STEPS = ['pending', 'confirmed', 'processing', 'shipped', 'delivered'];



          const STEP_META = {



            pending: { label: 'Order Placed', icon: '📋', color: '#6366f1' },



            confirmed: { label: 'Confirmed', icon: '✅', color: '#0ea5e9' },



            processing: { label: 'Processing', icon: '⚙️', color: '#f59e0b' },



            shipped: { label: 'Shipped', icon: '🚚', color: '#8b5cf6' },



            delivered: { label: 'Delivered', icon: '📦', color: '#10b981' },



            on_hold: { label: 'On Hold', icon: '⏸️', color: '#f97316' },



            cancelled: { label: 'Cancelled', icon: '❌', color: '#ef4444' },



            revised: { label: 'Revised', icon: '🔄', color: '#64748b' },



          };



          const terminalStatus = ['on_hold', 'cancelled', 'revised'].includes(o.status) ? o.status : null;



          const currentStepIdx = STATUS_STEPS.indexOf(o.status);



          const reachedSteps = terminalStatus ? [] : STATUS_STEPS.slice(0, currentStepIdx + 1);







          const fmtD = (d) => d ? new Date(d.split('T')[0] + 'T00:00:00').toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : null;



          const TYPE_LABEL_J = { invoice: 'Tax Invoice', proforma_invoice: 'Proforma', purchase_order: 'Purchase Order' };



          const REL_LABEL_J = { raw_material: 'Raw Material', reference: 'Reference', fulfillment: 'Fulfillment', return: 'Return', other: 'Other' };



          const REL_COLOR_J = { raw_material: '#7c3aed', reference: '#0369a1', fulfillment: '#047857', return: '#b45309', other: '#6b7280' };



          const REL_BG_J = { raw_material: '#f5f3ff', reference: '#e0f2fe', fulfillment: '#d1fae5', return: '#fef3c7', other: '#f3f4f6' };







          return (



            <>



              {/* ── Tab Bar ── */}



              <div style={{ display: 'flex', gap: 0, marginBottom: 18, borderBottom: '2px solid var(--border)' }}>



                {[['details', 'Details'], ['journey', 'Journey']].map(([key, label]) => (



                  <button key={key} type="button"



                    onClick={() => setViewTab(key)}



                    style={{



                      padding: '7px 20px', fontSize: '0.85rem', fontWeight: 600, border: 'none', background: 'none', cursor: 'pointer',



                      color: viewTab === key ? 'var(--primary)' : 'var(--text-muted)',



                      borderBottom: viewTab === key ? '2px solid var(--primary)' : '2px solid transparent',



                      marginBottom: -2, transition: 'color 0.15s',



                    }}>{label}</button>



                ))}



              </div>







              {/* ══════════ DETAILS TAB ══════════ */}



              {viewTab === 'details' && <>



                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16, alignItems: 'center' }}>



                  <span style={{ fontWeight: 700, fontSize: '1.05rem', color: 'var(--primary)' }}>{o.order_number}</span>



                  {o.order_type === 'invoice' && (



                    o.invoice_number



                      ? <span style={{ fontWeight: 700, fontSize: '0.88rem', padding: '2px 10px', borderRadius: 10, background: '#dcfce7', color: '#15803d', border: '1px solid #86efac' }}>INV: {o.invoice_number}</span>



                      : <span style={{ fontSize: '0.72rem', padding: '2px 8px', borderRadius: 10, background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a' }}>Invoice not yet generated</span>



                  )}



                  <span className={`badge badge-${statusColors[o.status]}`} style={{ textTransform: 'capitalize' }}>{o.status}</span>



                  <span style={{ fontSize: '0.75rem', padding: '2px 8px', borderRadius: 10, background: 'var(--surface-2)', color: 'var(--text-secondary)' }}>



                    {ORDER_TYPES.find(t => t.value === o.order_type)?.label || 'Invoice'}



                  </span>



                  {o.revised_from_id && (



                    <span style={{ fontSize: '0.72rem', padding: '2px 8px', borderRadius: 10, background: 'var(--warning-lighter, #fef3c7)', color: '#92400e', border: '1px solid #fde68a' }}>



                      Revision



                    </span>



                  )}



                  {o.status === 'revised' && (



                    <span style={{ fontSize: '0.72rem', padding: '2px 8px', borderRadius: 10, background: 'var(--surface-2)', color: 'var(--text-muted)', fontStyle: 'italic' }}>



                      Read-only — superseded by revision



                    </span>



                  )}



                </div>



                {/* ── IRN / E-Way Bill panel (Tax Invoice + admin/manager only) ── */}



                {o.order_type === 'invoice' && isPrivileged && (



                  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '12px 16px', marginBottom: 14 }}>



                    <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10 }}>e-Invoice &amp; E-Way Bill</div>



                    {(irnError || ewbError) && (



                      <div style={{ fontSize: '0.8rem', color: '#dc2626', marginBottom: 8, padding: '6px 10px', background: '#fef2f2', borderRadius: 6 }}>



                        {irnError || ewbError}



                      </div>



                    )}



                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>



                      {/* IRN status */}



                      {o.irn_status === 'generated' ? (



                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                          <span style={{ fontSize: '0.8rem', fontWeight: 600, padding: '4px 10px', borderRadius: 20, background: '#dcfce7', color: '#15803d', border: '1px solid #86efac' }}>



                            e-Invoice ✓ {o.irn_number ? `· IRN: ${o.irn_number.slice(0, 12)}…` : ''}



                          </span>



                          <button className="btn btn-sm" style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', fontSize: '0.75rem', padding: '3px 10px' }}



                            onClick={() => handleCancelIRN(o.id)} disabled={irnLoading}>



                            {irnLoading ? 'Cancelling…' : 'Cancel IRN'}



                          </button>



                        </div>



                      ) : (



                        <button className="btn btn-sm" style={{ background: '#166534', color: '#fff', border: 'none', fontSize: '0.78rem', padding: '5px 12px', display: 'flex', alignItems: 'center', gap: 5 }}



                          onClick={() => handleGenerateIRN(o.id)} disabled={irnLoading}>



                          {irnLoading



                            ? <><span className="spinner" style={{ width: 11, height: 11, borderWidth: 2, display: 'inline-block', marginRight: 4 }} />Generating…</>



                            : <><svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" style={{ marginRight: 3 }}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><polyline points="9 12 11 14 15 10" /></svg>Generate IRN</>}



                        </button>



                      )}







                      {/* E-Way Bill */}



                      {o.ewb_status === 'active' ? (



                        <span style={{ fontSize: '0.8rem', fontWeight: 600, padding: '4px 10px', borderRadius: 20, background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' }}>



                          EWB ✓ {o.ewb_number ? `· EWB: ${o.ewb_number}` : ''}



                        </span>



                      ) : (



                        <button className="btn btn-sm" style={{ background: '#1d4ed8', color: '#fff', border: 'none', fontSize: '0.78rem', padding: '5px 12px', display: 'flex', alignItems: 'center', gap: 5 }}



                          onClick={() => handleGenerateEWB(o.id)} disabled={ewbLoading}>



                          {ewbLoading



                            ? <><span className="spinner" style={{ width: 11, height: 11, borderWidth: 2, display: 'inline-block', marginRight: 4 }} />Generating…</>



                            : <><svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" style={{ marginRight: 3 }}><path d="M1 3h15l3 4-3 4H1z" /><path d="M16 7h5l3 4-3 4h-5" /><line x1="10" y1="7" x2="10" y2="15" /></svg>Generate E-Way Bill</>}



                        </button>



                      )}



                    </div>



                  </div>



                )}







                <div className="detail-grid" style={{ marginBottom: 16 }}>



                  {[



                    [o.party_type === 'customer' ? 'Customer' : 'Client', o.client_name],



                    ['Type', o.client_type ? o.client_type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : '—'],



                    ['Country', o.client_country || '—'],



                    ['Created by', o.user_name],



                    ['Currency', o.currency || '---'],



                    ['Quote #', o.quote_number || '---'],



                    ['Quote Date', o.quote_date ? new Date(o.quote_date.split('T')[0] + 'T00:00:00').toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '---'],



                    ['PO / Ref #', o.order_type === 'purchase_order' && o.status === 'confirmed' ? (o.invoice_number || '---') : (o.po_number || '---')],



                    ['PO Date', o.po_date ? new Date(o.po_date.split('T')[0] + 'T00:00:00').toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '---'],



                    ['Delivery', o.expected_delivery ? new Date(o.expected_delivery.split('T')[0] + 'T00:00:00').toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '---'],

                    ['GST Number', o.client_gstin || '---'],

                    ['Tax Invoice Date', o.invoice_date ? new Date(o.invoice_date.split('T')[0] + 'T00:00:00').toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '---'],



                  ].map(([label, value]) => (



                    <div key={label} className="detail-item">



                      <span className="detail-label">{label}</span>



                      <span className="detail-value">{value}</span>



                    </div>



                  ))}



                </div>





                {/* ── GST & Tax Invoice Information Panel ── */}
                <div style={{ background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', border: '1px solid #0ea5e9', borderRadius: 8, padding: '14px 16px', marginBottom: 16 }}>
                  <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#0369a1', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 10 }}>GST & Tax Invoice Information</div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: 2 }}>GST Number</span>
                      <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1e293b' }}>
                        {o.client_gstin ? (
                          <span style={{ background: '#dcfce7', color: '#15803d', padding: '2px 6px', borderRadius: 4, fontSize: '0.8rem' }}>
                            {o.client_gstin}
                          </span>
                        ) : (
                          <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>Not provided</span>
                        )}
                      </span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: 2 }}>Tax Invoice Date</span>
                      <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1e293b' }}>
                        {o.invoice_date ? (
                          <span style={{ background: '#fef3c7', color: '#92400e', padding: '2px 6px', borderRadius: 4, fontSize: '0.8rem' }}>
                            {new Date(o.invoice_date.split('T')[0] + 'T00:00:00').toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                          </span>
                        ) : (
                          <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>Not set</span>
                        )}
                      </span>
                    </div>
                  </div>
                </div>





                {(o.billing_address || o.shipping_address) && (



                  <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>



                    {o.billing_address && (



                      <div style={{ flex: 1, padding: '10px 12px', background: 'var(--surface-2)', borderRadius: 8, border: '1px solid var(--border)' }}>



                        <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 4 }}>Billing Address</div>



                        <div style={{ fontSize: '0.82rem', color: 'var(--text-primary)', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{o.billing_address}</div>



                      </div>



                    )}



                    {o.shipping_address && (



                      <div style={{ flex: 1, padding: '10px 12px', background: 'var(--surface-2)', borderRadius: 8, border: '1px solid var(--border)' }}>



                        <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 4 }}>Shipping Address</div>



                        <div style={{ fontSize: '0.82rem', color: 'var(--text-primary)', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{o.shipping_address}</div>



                      </div>



                    )}



                  </div>



                )}



                <div className="table-container" style={{ border: '1px solid var(--border)', borderRadius: 8, marginBottom: 14 }}>



                  <table className="table">



                    <thead><tr><th>Item</th><th>HSN Code</th><th>Pack</th><th>Batch No.</th>{viewModal.order?.order_type === 'purchase_order' && <th>Vendor Cat No.</th>}<th>Qty</th><th>Price</th><th>Disc%</th><th>Total</th></tr></thead>



                    <tbody>



                      {(o.items || []).map(it => (



                        <tr key={it.id}>



                          <td style={{ fontWeight: 500 }}>{it.item_name || '—'}</td>



                          <td>{it.hsn_code || '—'}</td>



                          <td>{it.pack_size || '—'}</td>



                          <td>{it.batch_number || '—'}</td>
                          {o.order_type === 'purchase_order' && <td>{it.catalog_number || '—'}</td>}



                          <td style={{ textAlign: 'center' }}>{it.quantity}</td>



                          <td style={{ textAlign: 'right' }}>{o.currency} {Number(it.price).toFixed(2)}</td>



                          <td style={{ textAlign: 'center' }}>{it.discount_percent || 0}%</td>



                          <td style={{ textAlign: 'right', fontWeight: 600 }}>{o.currency} {Number(it.total).toFixed(2)}</td>



                        </tr>



                      ))}



                    </tbody>



                  </table>



                </div>



                {/* Totals breakdown */}



                <div style={{ textAlign: 'right', background: 'var(--surface-2)', borderRadius: 8, padding: '10px 14px', marginBottom: 12, border: '1px solid var(--border)' }}>



                  <div style={{ fontSize: '0.875rem', color: 'var(--text-muted)', marginBottom: 4 }}>



                    Subtotal: {o.currency} {Number(o.subtotal).toFixed(2)}



                  </div>



                  {Number(o.discount_percent) > 0 && (



                    <div style={{ fontSize: '0.875rem', color: 'var(--error)', marginBottom: 4 }}>



                      Discount ({o.discount_percent}%): −{o.currency} {Number(o.discount_amount).toFixed(2)}



                    </div>



                  )}



                  <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 4 }}>



                    Taxable Amount: {o.currency} {netAmt.toFixed(2)}



                  </div>



                  {/* Tax breakdown */}



                  {o.tax_type === 'igst' && tRate > 0 && (



                    <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 4 }}>



                      IGST @{tRate}%: +{o.currency} {tAmt.toFixed(2)}



                    </div>



                  )}



                  {o.tax_type === 'cgst_sgst' && tRate > 0 && (



                    <>



                      <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 2 }}>CGST @{(tRate / 2).toFixed(1)}%: +{o.currency} {(tAmt / 2).toFixed(2)}</div>



                      <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 4 }}>SGST @{(tRate / 2).toFixed(1)}%: +{o.currency} {(tAmt / 2).toFixed(2)}</div>



                    </>



                  )}



                  {o.tax_type === 'custom' && tRate > 0 && (



                    <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 4 }}>



                      {o.tax_label || 'Tax'} @{tRate}%: +{o.currency} {tAmt.toFixed(2)}



                    </div>



                  )}



                  {o.tax_type === 'export' && (



                    <div style={{ fontSize: '0.78rem', color: 'var(--success)', marginBottom: 4 }}>Export / LUT — Zero-rated</div>



                  )}



                  {fAmt > 0 && <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 2 }}>Freight: +{o.currency} {fAmt.toFixed(2)}</div>}



                  {fGst > 0 && <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 2 }}>Freight GST: +{o.currency} {fGst.toFixed(2)}</div>}



                  {ordCharges.filter(c => Number(c.amount) > 0).map((c, i) => (



                    <React.Fragment key={i}>



                      <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 2 }}>{c.label || 'Extra Charge'}: +{o.currency} {Number(c.amount).toFixed(2)}</div>



                      {Number(c.gst_pct) > 0 && (



                        <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', marginBottom: 2, paddingLeft: 12 }}>



                          {c.label ? `${c.label} GST` : 'Charge GST'} ({c.gst_pct}%): +{o.currency} {(Number(c.amount) * Number(c.gst_pct) / 100).toFixed(2)}



                        </div>



                      )}



                    </React.Fragment>



                  ))}



                  <div style={{ fontWeight: 700, fontSize: '1.1rem', borderTop: '1px solid var(--border)', paddingTop: 6 }}>


                    Grand Total: {o.currency} {gTotal.toFixed(2)}


                  </div>


                  {['invoice', 'proforma_invoice'].includes(o.order_type) && !(user?.roles?.some(r => ['admin','manager'].includes(r)) || ['admin','manager'].includes(user?.role)) && (
                    <div style={{ marginTop: 6, fontSize: '0.9rem', fontWeight: 600, color: '#f59e0b' }}>
                      Commission: {Number(o.commission) > 0 ? `${o.currency} ${Number(o.commission).toFixed(2)}` : '—'}
                    </div>
                  )}


                  {['invoice', 'proforma_invoice'].includes(o.order_type) && (user?.roles?.some(r => ['admin','manager'].includes(r)) || ['admin','manager'].includes(user?.role)) && (
                    <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px dashed var(--border)', fontSize: '0.82rem', color: 'var(--text-muted)' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <span style={{ fontWeight: 600, color: '#f59e0b' }}>Commission (internal)</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <span style={{ fontSize: '0.82rem', fontWeight: 500 }}>{o.currency}</span>
                          <span style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-primary)' }}>
                            {Number(o.commission || 0).toFixed(2)}
                          </span>
                        </div>
                      </div>
                      


                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          defaultValue={o.commission || ''}
                          placeholder="Enter amount"
                          id={`commission-input-${o.id}`}
                          style={{ 
                            flex: 1,
                            padding: '6px 10px', 
                            border: '1px solid var(--border)', 
                            borderRadius: 6, 
                            fontSize: '0.82rem',
                            outline: 'none',
                            transition: 'border-color 0.2s'
                          }}
                          onFocus={(e) => e.target.style.borderColor = 'var(--primary)'}
                          onBlur={(e) => e.target.style.borderColor = 'var(--border)'}
                        />
                        <button
                          onClick={async () => {
                            const input = document.getElementById(`commission-input-${o.id}`);
                            const commissionValue = input.value === '' ? 0 : parseFloat(input.value);
                            


                            if (isNaN(commissionValue) || commissionValue < 0) {
                              setToast('Please enter a valid commission amount.');
                              setTimeout(() => setToast(''), 3000);
                              return;
                            }
                            


                            try {
                              setToast('Updating commission...');
                              const response = await api.patch(`/orders/${o.id}/commission`, { commission: commissionValue });
                              const { data: refreshed } = await api.get(`/orders/${o.id}`);
                              setViewModal(v => ({ ...v, order: refreshed.data }));
                              setToast('Commission updated successfully.');
                              setTimeout(() => setToast(''), 3000);
                              input.value = '';
                            } catch (err) {
                              console.error('Commission update error:', err);
                              const errorMessage = err.response?.data?.message || err.message || 'Failed to update commission.';
                              setToast(`Error: ${errorMessage}`);
                              setTimeout(() => setToast(''), 5000);
                            }
                          }}
                          style={{
                            padding: '6px 16px',
                            background: 'var(--primary)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 6,
                            fontSize: '0.82rem',
                            fontWeight: 500,
                            cursor: 'pointer',
                            transition: 'background-color 0.2s',
                            whiteSpace: 'nowrap'
                          }}
                          onMouseOver={(e) => e.target.style.backgroundColor = 'var(--primary-dark)'}
                          onMouseOut={(e) => e.target.style.backgroundColor = 'var(--primary)'}
                        >
                          Enter Amount
                        </button>
                      </div>
                    </div>
                  )}


                </div>


                {o.notes && (



                  <div style={{ marginTop: 12, padding: 12, background: 'var(--surface-2)', borderRadius: 8, fontSize: '0.875rem', color: 'var(--text-secondary)' }}>



                    {o.notes}



                  </div>



                )}







                {/* ── Material Received (Purchase Orders only) ── */}



                {o.order_type === 'purchase_order' && (() => {
                  const isReceived = (o.received_status === 'fully' || o.received_status === 'partial') && o.status === 'delivered';
                  const hasInvDoc = docs.some(d => d.doc_type === 'invoice');
                  return (
                    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '12px 16px', marginBottom: 14 }}>
                      <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10 }}></div>
                      {isReceived ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            {hasInvDoc ? (
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 12px', borderRadius: 20, background: '#dcfce7', color: '#15803d', border: '1px solid #86efac', fontSize: '0.82rem', fontWeight: 600 }}>
                                ✔ Material received – invoice document attached
                              </span>
                            ) : (
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 12px', borderRadius: 20, background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a', fontSize: '0.82rem', fontWeight: 600 }}>
                                ⚠️ PO completed – invoice document not attached
                              </span>
                            )}
                          </div>
                          <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>Order No: <strong>{o.order_number}</strong></div>
                          {o.invoice_number && <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>PO Number: <strong>{o.invoice_number}</strong></div>}
                          {o.vendor_invoice_number && <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>Vendor Invoice #: <strong>{o.vendor_invoice_number}</strong></div>}
                          {o.vendor_invoice_date && <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>Vendor Invoice Date: <strong>{o.vendor_invoice_date}</strong></div>}
                          {o.due_date && <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>Due Date: <strong>{o.due_date}</strong></div>}
                        </div>
                      ) : (
                        <div>
                          {poReceive.error && <div style={{ fontSize: '0.8rem', color: '#dc2626', marginBottom: 8, padding: '6px 10px', background: '#fef2f2', borderRadius: 6 }}>{poReceive.error}</div>}
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', alignItems: 'end', marginTop: 10 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>Vendor Invoice Number</label>
                              <input
                                type='text'
                                placeholder='Enter vendor invoice number'
                                value={poReceive.vendor_invoice_no}
                                onChange={e => setPoReceive(p => ({ ...p, vendor_invoice_no: e.target.value, error: '' }))}
                                style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid var(--border)', fontSize: '0.82rem', width: '100%', boxSizing: 'border-box' }}
                              />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>PO Number</label>
                              <input
                                type='text'
                                placeholder={viewModal.order?.status === 'confirmed' && viewModal.order?.invoice_number ? 'PO Number' : 'Enter PO number'}
                                value={poReceive.po_number || (viewModal.order?.status === 'confirmed' && viewModal.order?.invoice_number ? viewModal.order.invoice_number : '')}
                                onChange={e => setPoReceive(p => ({ ...p, po_number: e.target.value, error: '' }))}
                                style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid var(--border)', fontSize: '0.82rem', width: '100%', boxSizing: 'border-box' }}
                              />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>Vendor Invoice Date</label>
                              <input
                                type='date'
                                value={poReceive.vendor_invoice_date}
                                onChange={e => setPoReceive(p => ({ ...p, vendor_invoice_date: e.target.value, error: '' }))}
                                style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid var(--border)', fontSize: '0.82rem', width: '100%', boxSizing: 'border-box' }}
                              />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>Due Date</label>
                              <input
                                type='date'
                                value={poReceive.due_date}
                                onChange={e => setPoReceive(p => ({ ...p, due_date: e.target.value }))}
                                style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid var(--border)', fontSize: '0.82rem', width: '100%', boxSizing: 'border-box' }}
                              />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                              <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>Invoice Document (optional)</label>
                              <input
                                type='file'
                                accept='.pdf,.jpg,.jpeg,.png'
                                onChange={e => setPoReceive(p => ({ ...p, file: e.target.files[0] || null }))}
                                style={{ fontSize: '0.78rem', padding: '5px 0' }}
                              />
                            </div>
                            <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                              <button
                                onClick={handleReceivePO}
                                disabled={poReceive.saving}
                                style={{ padding: '8px 24px', borderRadius: 6, border: 'none', background: '#10b981', color: '#fff', fontWeight: 600, fontSize: '0.85rem', cursor: poReceive.saving ? 'not-allowed' : 'pointer', opacity: poReceive.saving ? 0.7 : 1, transition: 'all 0.2s ease' }}
                              >
                                {poReceive.saving ? 'Saving…' : 'Material Received'}
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })()}


                {/* ── Linked Orders sub-screen ── */}



                {(() => {



                  const hasSplits = o.parent_info || (o.split_orders && o.split_orders.length > 0);



                  const hasRelated = o.related_orders && o.related_orders.length > 0;



                  const TYPE_LABEL = { invoice: 'Invoice', proforma_invoice: 'Proforma', purchase_order: 'PO' };



                  const REL_LABEL = { raw_material: 'Raw Material', reference: 'Reference', fulfillment: 'Fulfillment', return: 'Return', other: 'Other' };



                  const REL_COLOR = { raw_material: '#7c3aed', reference: '#0369a1', fulfillment: '#047857', return: '#b45309', other: '#6b7280' };



                  const REL_BG = { raw_material: '#f5f3ff', reference: '#e0f2fe', fulfillment: '#d1fae5', return: '#fef3c7', other: '#f3f4f6' };



                  const OrderChip = ({ ord, onNav, onRemove }) => (



                    <div style={{ display: 'flex', alignItems: 'center', gap: 0, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', fontSize: '0.8rem' }}>



                      <button type="button" onClick={onNav}



                        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 10px', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 700, color: 'var(--primary)' }}>



                        {ord.order_number}



                        <span style={{ fontWeight: 400, color: 'var(--text-muted)', fontSize: '0.72rem' }}>{TYPE_LABEL[ord.order_type] || ord.order_type}</span>



                        <span className={`badge badge-${statusColors[ord.status] || 'neutral'}`} style={{ fontSize: '0.65rem', padding: '1px 6px' }}>{ord.status}</span>



                        {ord.client_name && <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>· {ord.client_name}</span>}



                      </button>



                      {onRemove && (



                        <button type="button" onClick={onRemove}



                          title="Unlink"



                          style={{ padding: '5px 8px', background: 'none', border: 'none', borderLeft: '1px solid var(--border)', cursor: 'pointer', color: '#ef4444', display: 'flex', alignItems: 'center' }}>



                          <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>



                        </button>



                      )}



                    </div>



                  );



                  return (



                    <div style={{ marginTop: 16, border: '1px solid var(--border)', borderRadius: 10, overflow: 'hidden' }}>



                      <div style={{ padding: '10px 16px', background: 'var(--surface-2)', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>



                        <div style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: 7 }}>



                          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>



                          Linked Orders



                          {(hasSplits || hasRelated) && (



                            <span style={{ fontSize: '0.72rem', fontWeight: 600, background: 'var(--primary-lighter)', color: 'var(--primary)', padding: '1px 7px', borderRadius: 10 }}>



                              {(o.split_orders?.length || 0) + (o.related_orders?.length || 0) + (o.parent_info ? 1 : 0)}



                            </span>



                          )}



                        </div>



                        <button type="button" className="btn btn-sm btn-secondary" style={{ fontSize: '0.75rem', padding: '3px 10px', display: 'flex', alignItems: 'center', gap: 5 }}



                          onClick={() => openLinkModal(o)}>



                          <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>



                          Link Order



                        </button>



                      </div>



                      <div style={{ padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>







                        {/* Split hierarchy */}



                        {(hasSplits) && (



                          <div>



                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Split Hierarchy</div>



                            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>



                              {o.parent_info && (



                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                                  <span style={{ fontSize: '0.7rem', color: 'var(--text-muted)', minWidth: 44 }}>Parent</span>



                                  <OrderChip ord={o.parent_info}



                                    onNav={async () => { const { data: r } = await api.get(`/orders/${o.parent_info.id}`); setViewModal({ open: true, order: r.data }); }} />



                                </div>



                              )}



                              {o.split_orders?.map(child => (



                                <div key={child.id} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                                  <span style={{ fontSize: '0.7rem', color: 'var(--text-muted)', minWidth: 44 }}>Split</span>



                                  <OrderChip ord={child}



                                    onNav={async () => { const { data: r } = await api.get(`/orders/${child.id}`); setViewModal({ open: true, order: r.data }); }} />



                                </div>



                              ))}



                            </div>



                          </div>



                        )}







                        {/* Related orders */}



                        {hasRelated && (



                          <div>



                            <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Related Orders</div>



                            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>



                              {o.related_orders.map(r => (



                                <div key={r.relation_id} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                                  <span style={{ fontSize: '0.68rem', fontWeight: 700, padding: '2px 7px', borderRadius: 6, background: REL_BG[r.relation_type] || '#f3f4f6', color: REL_COLOR[r.relation_type] || '#6b7280', minWidth: 44, textAlign: 'center', whiteSpace: 'nowrap' }}>



                                    {REL_LABEL[r.relation_type] || r.relation_type}



                                  </span>



                                  <OrderChip ord={{ id: r.linked_order_id, order_number: r.order_number, order_type: r.order_type, status: r.status, client_name: r.client_name }}



                                    onNav={async () => { const { data: res } = await api.get(`/orders/${r.linked_order_id}`); setViewModal({ open: true, order: res.data }); }}



                                    onRemove={() => handleRemoveRelation(o.id, r.relation_id)} />



                                  {r.relation_notes && <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>{r.relation_notes}</span>}



                                </div>



                              ))}



                            </div>



                          </div>



                        )}







                        {!hasSplits && !hasRelated && (



                          <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', textAlign: 'center', padding: '8px 0' }}>



                            No linked orders yet. Use <strong>Link Order</strong> to connect related orders (e.g. raw material POs, fulfillment orders).



                          </div>



                        )}



                      </div>



                    </div>



                  );



                })()}







                {/* ── Assignments summary ── */}



                {o.assignments && o.assignments.length > 0 && (



                  <div style={{ marginTop: 12, padding: '10px 14px', background: 'var(--surface-2)', borderRadius: 8, border: '1px solid var(--border)' }}>



                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>



                      <span style={{ fontWeight: 700, fontSize: '0.82rem', color: 'var(--text-secondary)' }}>Assigned To</span>



                      <button className="btn btn-ghost btn-sm" style={{ fontSize: '0.75rem', padding: '2px 8px' }}



                        onClick={() => { setViewModal({ open: false }); openAssignModal(o); }}>



                        Manage



                      </button>



                    </div>



                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>



                      {o.assignments.map(a => (



                        <span key={a.id} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 20, background: a.access_level === 'read_write' ? 'var(--primary-lighter)' : 'var(--surface)', border: '1px solid var(--border)', fontSize: '0.78rem' }}>



                          <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>



                          {a.user_name}



                          <span style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginLeft: 2 }}>



                            {a.access_level === 'read_write' ? 'RW' : 'RO'}



                          </span>



                        </span>



                      ))}



                    </div>



                  </div>



                )}







                {/* ── Shipping / Delhivery Section ── */}



                {(o.order_type === 'invoice' || o.order_type === 'proforma_invoice' || o.order_type === 'purchase_order') && (



                  <ShippingSection



                    order={o}



                    onShipmentCreated={(data) => setViewModal(v => ({



                      ...v,



                      order: { ...v.order, waybill_number: data.waybill, tracking_url: data.tracking_url, shipping_status: data.shipping_status || 'booked' }



                    }))}



                    onWaybillUpdated={(updated) => setViewModal(v => ({



                      ...v,



                      order: { ...v.order, waybill_number: updated.waybill_number, waybill_date: updated.waybill_date }



                    }))}



                  />



                )}







                {/* ── Documents Section ── */}



                <div style={{ marginTop: 20, borderTop: '1px solid var(--border)', paddingTop: 16 }}>



                  <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 12, color: 'var(--text-primary)' }}>



                    Attached Documents



                  </div>



                  <div style={{ background: 'var(--surface-2)', borderRadius: 8, padding: 14, marginBottom: 14, border: '1px solid var(--border)' }}>



                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>



                      <div className="form-group" style={{ marginBottom: 0, minWidth: 140 }}>



                        <label className="form-label" style={{ fontSize: '0.78rem' }}>Document Type</label>



                        <select className="form-control form-select" style={{ fontSize: '0.83rem' }}



                          value={docForm.doc_type}



                          onChange={e => setDocForm(p => ({ ...p, doc_type: e.target.value, doc_description: '' }))}>



                          <option value="po">PO</option>



                          <option value="invoice">Invoice</option>



                          <option value="quote">Quote</option>



                          <option value="others">Others</option>



                        </select>



                      </div>



                      {docForm.doc_type === 'others' && (



                        <div className="form-group" style={{ marginBottom: 0, flex: 1, minWidth: 140 }}>



                          <label className="form-label" style={{ fontSize: '0.78rem' }}>Describe Type *</label>



                          <input className="form-control" style={{ fontSize: '0.83rem' }} placeholder="e.g. COA, NDA, Agreement…"



                            value={docForm.doc_description}



                            onChange={e => setDocForm(p => ({ ...p, doc_description: e.target.value }))} />



                        </div>



                      )}



                      <div className="form-group" style={{ marginBottom: 0, flex: 2, minWidth: 160 }}>



                        <label className="form-label" style={{ fontSize: '0.78rem' }}>File</label>



                        <input type="file" className="form-control" style={{ fontSize: '0.83rem' }}



                          accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.webp,.txt"



                          onChange={e => setDocForm(p => ({ ...p, file: e.target.files[0] || null }))} />



                      </div>



                      <button className="btn btn-primary btn-sm" onClick={handleDocUpload} disabled={docUploading}



                        style={{ whiteSpace: 'nowrap', marginBottom: 2 }}>



                        {docUploading ? 'Uploading…' : 'Attach'}



                      </button>



                    </div>



                    {docError && <div style={{ marginTop: 8, color: 'var(--error)', fontSize: '0.8rem' }}>{docError}</div>}



                  </div>



                  {docs.length === 0 ? (



                    <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.85rem', padding: '12px 0' }}>



                      No documents attached yet.



                    </div>



                  ) : (



                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>



                      {docs.map(doc => (



                        <div key={doc.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8 }}>



                          <div style={{ fontSize: '1.2rem' }}>{docTypeIcon(doc.original_name)}</div>



                          <div style={{ flex: 1, minWidth: 0 }}>



                            <div style={{ fontWeight: 600, fontSize: '0.83rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>



                              {doc.original_name}



                            </div>



                            <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>



                              <span style={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px', color: 'var(--primary)' }}>



                                {doc.doc_type === 'others' && doc.doc_description ? doc.doc_description : doc.doc_type.toUpperCase()}



                              </span>



                              {' · '}{doc.uploaded_by_name}



                              {' · '}{new Date(doc.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}



                              {doc.file_size ? ` · ${(doc.file_size / 1024).toFixed(1)} KB` : ''}



                            </div>



                          </div>



                          <button className="btn btn-ghost btn-icon btn-sm" data-tooltip="Download"



                            onClick={() => handleDocDownload(doc.id, doc.original_name)}>



                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>



                          </button>



                          <button className="btn btn-ghost btn-icon btn-sm" data-tooltip="Delete"



                            style={{ color: 'var(--error)' }} onClick={() => handleDocDelete(doc.id)}>



                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4h6v2" /></svg>



                          </button>



                        </div>



                      ))}



                    </div>



                  )}



                </div>







                {/* ── Activity History ── */}



                <EntityHistory entity="order" entityId={viewModal.order?.id} />



              </>}



              {/* ══════════ JOURNEY TAB ══════════ */}



              {viewTab === 'journey' && (() => {



                /* ── pit-stop colours ── */



                const done = { bg: '#10b981', border: '#059669', text: '#fff' };



                const curr = { bg: 'var(--primary)', border: 'var(--primary)', text: '#fff' };



                const todo = { bg: '#f1f5f9', border: '#cbd5e1', text: '#94a3b8' };







                const Dot = ({ step, idx }) => {



                  const reached = reachedSteps.includes(step);



                  const isCurr = o.status === step;



                  const theme = isCurr ? curr : (reached ? done : todo);



                  const meta = STEP_META[step] || {};



                  const isLast = idx === STATUS_STEPS.length - 1;



                  return (



                    <div style={{ display: 'flex', alignItems: 'center', flex: isLast ? 0 : 1 }}>



                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, minWidth: 64 }}>



                        {/* circle */}



                        <div style={{



                          width: 42, height: 42, borderRadius: '50%',



                          background: theme.bg, border: `3px solid ${theme.border}`,



                          display: 'flex', alignItems: 'center', justifyContent: 'center',



                          fontSize: 18, boxShadow: isCurr ? `0 0 0 4px ${theme.border}33` : 'none',



                          transition: 'all 0.2s',



                        }}>{meta.icon}</div>



                        {/* label */}



                        <div style={{ textAlign: 'center' }}>



                          <div style={{ fontSize: '0.72rem', fontWeight: isCurr ? 700 : 500, color: isCurr ? 'var(--primary)' : (reached ? '#374151' : '#94a3b8'), whiteSpace: 'nowrap' }}>



                            {meta.label}



                          </div>



                          {isCurr && (



                            <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)', marginTop: 1 }}>{fmtD(o.updated_at || o.created_at)}</div>



                          )}



                          {step === 'pending' && (



                            <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)', marginTop: 1 }}>{fmtD(o.created_at)}</div>



                          )}



                          {step === 'delivered' && o.invoice_number && (



                            <div style={{ fontSize: '0.62rem', color: '#15803d', fontWeight: 700, marginTop: 2 }}>INV: {o.invoice_number}</div>



                          )}



                        </div>



                      </div>



                      {/* connector line */}



                      {!isLast && (



                        <div style={{



                          flex: 1, height: 3, borderRadius: 2, margin: '0 4px', marginBottom: 28,



                          background: reached ? 'linear-gradient(90deg,#10b981,#10b981)' : '#e2e8f0',



                        }} />



                      )}



                    </div>



                  );



                };







                /* terminal status banner */



                const terminal = terminalStatus ? STEP_META[terminalStatus] : null;







                /* ── Tree node ── */



                const TreeNode = ({ order: n, isRoot, isParent, relType, relBg, relColor, onNav }) => (



                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>



                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>



                      <div style={{ width: 10, height: 10, borderRadius: '50%', background: isRoot ? 'var(--primary)' : (isParent ? '#64748b' : '#0ea5e9'), flexShrink: 0, marginTop: 8 }} />



                    </div>



                    <div style={{



                      flex: 1, padding: '8px 12px', borderRadius: 8, cursor: 'pointer',



                      border: isRoot ? '2px solid var(--primary)' : '1px solid var(--border)',



                      background: isRoot ? 'var(--primary-lighter, #eff6ff)' : 'var(--surface)',



                      transition: 'box-shadow 0.15s',



                    }}



                      onClick={onNav}>



                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>



                        {relType && (



                          <span style={{ fontSize: '0.65rem', fontWeight: 700, padding: '1px 6px', borderRadius: 5, background: relBg, color: relColor }}>{relType}</span>



                        )}



                        {isParent && <span style={{ fontSize: '0.65rem', fontWeight: 700, padding: '1px 6px', borderRadius: 5, background: '#f1f5f9', color: '#64748b' }}>Parent</span>}



                        {isRoot && <span style={{ fontSize: '0.65rem', fontWeight: 700, padding: '1px 6px', borderRadius: 5, background: 'var(--primary)', color: '#fff' }}>This Order</span>}



                        <span style={{ fontWeight: 700, fontSize: '0.85rem', color: isRoot ? 'var(--primary)' : 'var(--text-primary)' }}>{n.order_number}</span>



                        <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{TYPE_LABEL_J[n.order_type] || n.order_type}</span>



                        <span className={`badge badge-${statusColors[n.status] || 'neutral'}`} style={{ fontSize: '0.65rem', padding: '1px 6px' }}>{n.status}</span>



                        {n.client_name && <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>· {n.client_name}</span>}



                      </div>



                      {n.total !== undefined && (



                        <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 3 }}>



                          {n.currency || o.currency} {Number(n.total || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}



                          {n.created_at && <span style={{ marginLeft: 8 }}>{fmtD(n.created_at)}</span>}



                        </div>



                      )}



                    </div>



                  </div>



                );







                const navTo = async (id) => { const { data: r } = await api.get(`/orders/${id}`); setViewModal({ open: true, order: r.data }); setViewTab('journey'); };







                return (



                  <div>



                    {/* ── Status Timeline ── */}



                    <div style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 12, padding: '20px 16px', marginBottom: 20 }}>



                      <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-muted)', marginBottom: 16 }}>Order Lifecycle</div>



                      <div style={{ display: 'flex', alignItems: 'flex-start', overflowX: 'auto', paddingBottom: 4 }}>



                        {STATUS_STEPS.map((step, idx) => (



                          <Dot key={step} step={step} idx={idx} />



                        ))}



                      </div>



                      {terminal && (



                        <div style={{ marginTop: 16, display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 8, background: terminal.color + '18', border: `1px solid ${terminal.color}55` }}>



                          <span style={{ fontSize: 20 }}>{terminal.icon}</span>



                          <div>



                            <div style={{ fontWeight: 700, fontSize: '0.88rem', color: terminal.color }}>{terminal.label}</div>



                            {o.status === 'revised' && o.revised_from_id && <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 2 }}>This order was revised. See linked revision below.</div>}



                            {o.status === 'cancelled' && <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 2 }}>Order was cancelled before fulfilment.</div>}



                            {o.status === 'on_hold' && <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 2 }}>Order is currently on hold.</div>}



                          </div>



                        </div>



                      )}



                      {/* Key milestones row */}



                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 16, paddingTop: 14, borderTop: '1px solid var(--border)' }}>



                        {[



                          ['Created', fmtD(o.created_at)],



                          o.po_date ? ['PO Date', fmtD(o.po_date)] : null,



                          o.expected_delivery ? ['Expected Delivery', fmtD(o.expected_delivery)] : null,



                          o.quote_date ? ['Quote Date', fmtD(o.quote_date)] : null,



                          o.waybill_date ? ['Waybill Date', fmtD(o.waybill_date)] : null,



                          o.invoice_number ? ['Invoice #', o.invoice_number] : null,

                          ['Invoice Date', o.invoice_date ? fmtD(o.invoice_date) : 'Not set'],

                          ['GST Number', o.client_gstin || 'Not set'],



                        ].filter(Boolean).map(([label, val]) => (



                          <div key={label} style={{ padding: '5px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8, fontSize: '0.75rem' }}>



                            <span style={{ color: 'var(--text-muted)' }}>{label}: </span>



                            <span style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{val}</span>



                          </div>



                        ))}



                      </div>



                    </div>







                    {/* ── Order Tree ── */}



                    <div style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 12, padding: '16px' }}>



                      <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-muted)', marginBottom: 14 }}>Order Network</div>







                      {/* Parent (if split child) */}



                      {o.parent_info && (



                        <div style={{ marginBottom: 6 }}>



                          <TreeNode order={o.parent_info} isParent onNav={() => navTo(o.parent_info.id)} />



                          <div style={{ marginLeft: 18, width: 2, height: 14, background: '#cbd5e1', marginBottom: 0 }} />



                        </div>



                      )}







                      {/* Current order */}



                      <TreeNode order={{ ...o, currency: o.currency, total: o.total, client_name: o.client_name }} isRoot onNav={() => { }} />







                      {/* Split children */}



                      {o.split_orders && o.split_orders.length > 0 && (



                        <div style={{ marginLeft: 28, marginTop: 4 }}>



                          <div style={{ borderLeft: '2px dashed #94a3b8', paddingLeft: 14, display: 'flex', flexDirection: 'column', gap: 6 }}>



                            <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#0369a1', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2, marginTop: 4 }}>



                              ↳ {o.split_orders.length} Split Order{o.split_orders.length > 1 ? 's' : ''}



                            </div>



                            {o.split_orders.map(child => (



                              <TreeNode key={child.id} order={child} onNav={() => navTo(child.id)} />



                            ))}



                          </div>



                        </div>



                      )}







                      {/* Related orders */}



                      {o.related_orders && o.related_orders.length > 0 && (



                        <div style={{ marginTop: 14, paddingTop: 12, borderTop: '1px dashed var(--border)' }}>



                          <div style={{ fontSize: '0.68rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>Related Orders</div>



                          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>



                            {o.related_orders.map(r => (



                              <TreeNode



                                key={r.relation_id}



                                order={{ id: r.linked_order_id, order_number: r.order_number, order_type: r.order_type, status: r.status, client_name: r.client_name, total: r.total, currency: r.currency, created_at: r.created_at }}



                                relType={REL_LABEL_J[r.relation_type] || r.relation_type}



                                relBg={REL_BG_J[r.relation_type] || '#f3f4f6'}



                                relColor={REL_COLOR_J[r.relation_type] || '#6b7280'}



                                onNav={() => navTo(r.linked_order_id)}



                              />



                            ))}



                          </div>



                        </div>



                      )}







                      {!o.parent_info && !(o.split_orders?.length) && !(o.related_orders?.length) && (



                        <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', textAlign: 'center', padding: '12px 0', marginTop: 8 }}>



                          No linked orders. Use <strong>Link Order</strong> in the Details tab to connect related orders.



                        </div>



                      )}



                    </div>



                  </div>



                );



              })()}



            </>



          );



        })()}



      </Modal>







      {/* ── Split Order Modal ─────────────────────────────────── */}



      <Modal open={splitModal.open} onClose={() => setSplitModal({ open: false, parent: null })}



        title={`Split Order — ${splitModal.parent?.order_number || ''}`} size="lg"



        footer={<>



          <button className="btn btn-secondary" onClick={() => setSplitModal({ open: false, parent: null })}>Cancel</button>



          <button className="btn btn-primary" onClick={handleSplit} disabled={splitSaving}>



            {splitSaving ? 'Creating…' : 'Create Split Order'}



          </button>



        </>}



      >



        {splitModal.parent && (



          <div>



            {splitError && <div className="alert alert-error" style={{ marginBottom: 12, fontSize: '0.83rem' }}>{splitError}</div>}







            {/* Type + PO + Discount row */}



            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>



              <div className="form-group" style={{ marginBottom: 0, minWidth: 170 }}>



                <label className="form-label">New Order Type *</label>



                <select className="form-control form-select"



                  value={splitForm.order_type}



                  onChange={e => setSplitForm(p => ({ ...p, order_type: e.target.value }))}>



                  <option value="invoice">Tax Invoice</option>



                  <option value="proforma_invoice">Proforma Invoice</option>



                  <option value="purchase_order">Purchase Order</option>



                </select>



              </div>



              <div className="form-group" style={{ marginBottom: 0, flex: 1, minWidth: 140 }}>



                <label className="form-label">PO / Ref Number</label>



                <input className="form-control" placeholder="Optional reference…"



                  value={splitForm.po_number}



                  onChange={e => setSplitForm(p => ({ ...p, po_number: e.target.value }))} />



              </div>



              <div className="form-group" style={{ marginBottom: 0, width: 100 }}>



                <label className="form-label">Discount %</label>



                <input type="number" className="form-control" min={0} max={100} step={0.01}



                  value={splitForm.discount_percent}



                  onChange={e => setSplitForm(p => ({ ...p, discount_percent: e.target.value }))} />



              </div>



            </div>







            {/* Items selection table */}



            <div style={{ fontWeight: 600, fontSize: '0.83rem', marginBottom: 8 }}>



              Select Items &amp; Quantities



              <span style={{ fontWeight: 400, fontSize: '0.75rem', color: 'var(--text-muted)', marginLeft: 8 }}>



                (parent: {splitModal.parent.order_number} — {splitModal.parent.items?.length || 0} items)



              </span>



            </div>



            <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', marginBottom: 14 }}>



              <table className="table" style={{ marginBottom: 0, fontSize: '0.82rem' }}>



                <thead>



                  <tr style={{ background: 'var(--surface-2)' }}>



                    <th style={{ width: 36, textAlign: 'center' }}>



                      <input type="checkbox"



                        checked={splitForm.items.every(it => it.included)}



                        onChange={e => setSplitForm(p => ({ ...p, items: p.items.map(it => ({ ...it, included: e.target.checked })) }))} />



                    </th>



                    <th>Product</th>



                    <th>Pack</th>



                    <th style={{ textAlign: 'right' }}>Orig. Qty</th>



                    <th style={{ textAlign: 'right' }}>Price</th>



                    <th style={{ width: 90, textAlign: 'center' }}>Split Qty</th>



                  </tr>



                </thead>



                <tbody>



                  {splitForm.items.map((it, idx) => (



                    <tr key={idx} style={{ opacity: it.included ? 1 : 0.4 }}>



                      <td style={{ textAlign: 'center' }}>



                        <input type="checkbox" checked={it.included}



                          onChange={e => setSplitForm(p => ({ ...p, items: p.items.map((x, i) => i === idx ? { ...x, included: e.target.checked } : x) }))} />



                      </td>



                      <td>



                        <div style={{ fontWeight: 600 }}>{it.item_name}</div>



                        {it.batch_number && <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Batch: {it.batch_number}</div>}



                      </td>



                      <td style={{ color: 'var(--text-muted)' }}>{it.pack_size || '—'}</td>



                      <td style={{ textAlign: 'right', color: 'var(--text-muted)' }}>{it.quantity}</td>



                      <td style={{ textAlign: 'right' }}>{splitModal.parent.currency} {Number(it.price).toFixed(2)}</td>



                      <td style={{ textAlign: 'center' }}>



                        <input type="number" className="form-control" min={1} max={it.quantity}



                          style={{ width: 70, textAlign: 'center', fontSize: '0.82rem', padding: '3px 6px' }}



                          value={it.split_qty}



                          disabled={!it.included}



                          onChange={e => {



                            const v = Math.max(1, Math.min(Number(e.target.value) || 1, it.quantity));



                            setSplitForm(p => ({ ...p, items: p.items.map((x, i) => i === idx ? { ...x, split_qty: v } : x) }));



                          }} />



                      </td>



                    </tr>



                  ))}



                </tbody>



              </table>



            </div>







            {/* Notes */}



            <div className="form-group" style={{ marginBottom: 0 }}>



              <label className="form-label">Notes</label>



              <textarea className="form-control" rows={2} placeholder="Optional notes for this split order…"



                value={splitForm.notes}



                onChange={e => setSplitForm(p => ({ ...p, notes: e.target.value }))} />



            </div>







            {/* Preview total */}



            {(() => {



              const selItems = splitForm.items.filter(it => it.included);



              const sub = selItems.reduce((s, it) => s + Number(it.price) * Number(it.split_qty) * (1 - (Number(it.discount_percent) || 0) / 100), 0);



              const disc = sub * (Number(splitForm.discount_percent) || 0) / 100;



              return selItems.length > 0 ? (



                <div style={{ marginTop: 12, padding: '8px 12px', background: 'var(--surface-2)', borderRadius: 8, fontSize: '0.83rem', display: 'flex', gap: 16 }}>



                  <span style={{ color: 'var(--text-secondary)' }}>{selItems.length} item{selItems.length !== 1 ? 's' : ''} selected</span>



                  <span style={{ color: 'var(--text-secondary)' }}>Subtotal: <strong>{splitModal.parent.currency} {sub.toFixed(2)}</strong></span>



                  {disc > 0 && <span style={{ color: 'var(--text-secondary)' }}>Discount: <strong>−{splitModal.parent.currency} {disc.toFixed(2)}</strong></span>}



                  <span style={{ fontWeight: 700, marginLeft: 'auto' }}>Est. Total: {splitModal.parent.currency} {(sub - disc).toFixed(2)}</span>



                </div>



              ) : null;



            })()}



          </div>



        )}



      </Modal>







      {/* ── Link Order Modal ─────────────────────────────────── */}



      <Modal open={linkModal.open} onClose={() => setLinkModal({ open: false, orderId: null, orderNum: '' })}



        title={`Link Related Order — ${linkModal.orderNum || ''}`} size="sm"



        footer={



          <>



            <button className="btn btn-secondary" onClick={() => setLinkModal({ open: false, orderId: null, orderNum: '' })}>Cancel</button>



            <button className="btn btn-primary" onClick={handleAddRelation} disabled={linkSaving || !linkSelected}>



              {linkSaving ? 'Linking…' : 'Link Order'}



            </button>



          </>



        }



      >



        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>



          {linkError && <div style={{ background: '#fee2e2', color: '#dc2626', borderRadius: 7, padding: '7px 12px', fontSize: '0.83rem' }}>{linkError}</div>}







          {/* Order search */}



          <div>



            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>



              Search Order to Link *



            </label>



            <input className="form-control" placeholder="Type order number, PO number, or client name…"



              value={linkQuery}



              onChange={e => searchOrdersForLink(e.target.value)} />



            {linkResults.length > 0 && !linkSelected && (



              <div style={{ border: '1px solid var(--border)', borderRadius: 8, marginTop: 4, maxHeight: 220, overflowY: 'auto', background: 'var(--surface)' }}>



                {linkResults.map(r => (



                  <button key={r.id} type="button"



                    onClick={() => { setLinkSelected(r); setLinkQuery(r.order_number); setLinkResults([]); }}



                    style={{ width: '100%', textAlign: 'left', padding: '8px 12px', background: 'none', border: 'none', borderBottom: '1px solid var(--border)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}



                    onMouseEnter={e => e.currentTarget.style.background = 'var(--surface-2)'}



                    onMouseLeave={e => e.currentTarget.style.background = 'none'}>



                    <div>



                      <span style={{ fontWeight: 700, fontSize: '0.85rem' }}>{r.order_number}</span>



                      {r.client_name && <span style={{ marginLeft: 6, fontSize: '0.78rem', color: 'var(--text-muted)' }}>{r.client_name}</span>}



                    </div>



                    <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>



                      <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{{ invoice: 'Invoice', proforma_invoice: 'Proforma', purchase_order: 'PO' }[r.order_type]}</span>



                      <span className={`badge badge-${statusColors[r.status] || 'neutral'}`} style={{ fontSize: '0.65rem' }}>{r.status}</span>



                    </div>



                  </button>



                ))}



              </div>



            )}



            {linkSelected && (



              <div style={{ marginTop: 6, padding: '6px 10px', background: 'var(--primary-lighter)', borderRadius: 7, border: '1px solid var(--primary)', fontSize: '0.82rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>



                <span><strong>{linkSelected.order_number}</strong> — {linkSelected.client_name || ''}</span>



                <button type="button" onClick={() => { setLinkSelected(null); setLinkQuery(''); }}



                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--primary)', fontSize: '0.8rem' }}>✕ Clear</button>



              </div>



            )}



          </div>







          {/* Relation type */}



          <div>



            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>Relation Type</label>



            <select className="form-control form-select" value={linkForm.relation_type}



              onChange={e => setLinkForm(f => ({ ...f, relation_type: e.target.value }))}>



              <option value="raw_material">Raw Material — procuring inputs for this order</option>



              <option value="fulfillment">Fulfillment — ships / fulfils another order</option>



              <option value="reference">Reference — general cross-reference</option>



              <option value="return">Return / Refund</option>



              <option value="other">Other</option>



            </select>



          </div>







          {/* Notes */}



          <div>



            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>Notes (optional)</label>



            <input className="form-control" placeholder="e.g. RM for batch #B202" value={linkForm.notes}



              onChange={e => setLinkForm(f => ({ ...f, notes: e.target.value }))} />



          </div>



        </div>



      </Modal>







      {/* ── Assignments & Work Logs Modal ─────────────────────── */}



      <Modal open={assignModal.open} onClose={() => setAssignModal({ open: false, orderId: null, orderNum: '', ownerId: null })}



        title={`Assignments — ${assignModal.orderNum || ''}`} size="md"



        footer={<button className="btn btn-secondary" onClick={() => setAssignModal({ open: false, orderId: null, orderNum: '', ownerId: null })}>Close</button>}



      >



        {/* Tabs */}



        <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: 16, gap: 0 }}>



          {['assignments', 'worklogs'].map(tab => (



            <button key={tab} onClick={() => setAssignTab(tab)}



              style={{ padding: '7px 18px', background: 'none', border: 'none', borderBottom: assignTab === tab ? '2px solid var(--primary)' : '2px solid transparent', fontWeight: assignTab === tab ? 700 : 400, color: assignTab === tab ? 'var(--primary)' : 'var(--text-secondary)', cursor: 'pointer', fontSize: '0.85rem' }}>



              {tab === 'assignments' ? 'Assignments' : 'Work Logs'}



            </button>



          ))}



        </div>







        {assignTab === 'assignments' && (



          <div>



            {/* Existing assignments */}



            {assignments.length === 0 ? (



              <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.85rem', padding: '10px 0 16px' }}>No assignees yet.</div>



            ) : (



              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 }}>



                {assignments.map(a => (



                  <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', background: 'var(--surface-2)', borderRadius: 8, border: '1px solid var(--border)' }}>



                    <div style={{ flex: 1 }}>



                      <div style={{ fontWeight: 600, fontSize: '0.85rem' }}>{a.user_name}</div>



                      <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>



                        {a.user_role} · Assigned by {a.assigned_by_name || '—'} · {new Date(a.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}



                      </div>



                      {a.notes && <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: 2, fontStyle: 'italic' }}>{a.notes}</div>}



                    </div>



                    {/* Access level toggle — only owner/privileged */}



                    {(isPrivileged || user?.id === assignModal.ownerId) && (



                      <select className="form-control form-select" style={{ fontSize: '0.78rem', width: 120, padding: '3px 6px' }}



                        value={a.access_level}



                        onChange={e => handleUpdateAssignment(a.id, e.target.value)}>



                        <option value="read_only">Read Only</option>



                        <option value="read_write">Read + Write</option>



                      </select>



                    )}



                    {/* Read-only badge for non-owner/manager */}



                    {!(isPrivileged || user?.id === assignModal.ownerId) && (



                      <span style={{ fontSize: '0.72rem', padding: '2px 8px', borderRadius: 12, background: a.access_level === 'read_write' ? 'var(--primary-lighter)' : 'var(--surface)', border: '1px solid var(--border)', color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>



                        {a.access_level === 'read_write' ? 'Read + Write' : 'Read Only'}



                      </span>



                    )}



                    {(isPrivileged || user?.id === assignModal.ownerId) && (



                      <button className="btn btn-ghost btn-icon btn-sm" data-tooltip="Remove" style={{ color: 'var(--error)' }}



                        onClick={() => handleRemoveAssignment(a.id, a.user_name)}>



                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>



                      </button>



                    )}



                  </div>



                ))}



              </div>



            )}







            {/* Add assignment form — owner, privileged, or read-write assignees */}



            {(isPrivileged || user?.id === assignModal.ownerId ||



              assignments.some(a => a.user_id === user?.id && a.access_level === 'read_write')) && (



                <div style={{ background: 'var(--surface-2)', borderRadius: 8, padding: 14, border: '1px solid var(--border)' }}>



                  <div style={{ fontWeight: 600, fontSize: '0.83rem', marginBottom: 10 }}>Add Assignee</div>



                  {assignError && <div className="alert alert-error" style={{ marginBottom: 10, fontSize: '0.8rem', padding: '6px 10px' }}>{assignError}</div>}



                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>



                    <div className="form-group" style={{ marginBottom: 0, flex: 2, minWidth: 150 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>User</label>



                      <select className="form-control form-select" style={{ fontSize: '0.83rem' }}



                        value={assignForm.user_id}



                        onChange={e => setAssignForm(p => ({ ...p, user_id: e.target.value }))}>



                        <option value="">— Select user —</option>



                        {assignUsers



                          .filter(u => u.id !== assignModal.ownerId && !assignments.some(a => a.user_id === u.id))



                          .map(u => <option key={u.id} value={u.id}>{u.name} ({u.role})</option>)}



                      </select>



                    </div>



                    <div className="form-group" style={{ marginBottom: 0, flex: 1, minWidth: 130 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>Access</label>



                      <select className="form-control form-select" style={{ fontSize: '0.83rem' }}



                        value={assignForm.access_level}



                        onChange={e => setAssignForm(p => ({ ...p, access_level: e.target.value }))}>



                        <option value="read_only">Read Only</option>



                        <option value="read_write">Read + Write</option>



                      </select>



                    </div>



                    <div className="form-group" style={{ marginBottom: 0, flex: 2, minWidth: 150 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>Note (optional)</label>



                      <input className="form-control" style={{ fontSize: '0.83rem' }} placeholder="e.g. Handling dispatch…"



                        value={assignForm.notes}



                        onChange={e => setAssignForm(p => ({ ...p, notes: e.target.value }))} />



                    </div>



                    <button className="btn btn-primary btn-sm" onClick={handleAddAssignment} disabled={assignSaving}



                      style={{ whiteSpace: 'nowrap', marginBottom: 2 }}>



                      {assignSaving ? 'Assigning…' : 'Assign'}



                    </button>



                  </div>



                </div>



              )}



          </div>



        )}







        {assignTab === 'worklogs' && (



          <div>



            {/* Work log entry form — owner, privileged, or read-write assignees */}



            {(isPrivileged || user?.id === assignModal.ownerId ||



              assignments.some(a => a.user_id === user?.id && a.access_level === 'read_write')) && (



                <div style={{ background: 'var(--surface-2)', borderRadius: 8, padding: 14, border: '1px solid var(--border)', marginBottom: 16 }}>



                  <div style={{ fontWeight: 600, fontSize: '0.83rem', marginBottom: 10 }}>Add Work Log</div>



                  {wlError && <div className="alert alert-error" style={{ marginBottom: 10, fontSize: '0.8rem', padding: '6px 10px' }}>{wlError}</div>}



                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>



                    <div className="form-group" style={{ marginBottom: 0, minWidth: 130 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>Type</label>



                      <select className="form-control form-select" style={{ fontSize: '0.83rem' }}



                        value={wlForm.log_type}



                        onChange={e => setWlForm(p => ({ ...p, log_type: e.target.value }))}>



                        {['note', 'call', 'meeting', 'email', 'visit', 'follow_up', 'other'].map(t => (



                          <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1).replace('_', ' ')}</option>



                        ))}



                      </select>



                    </div>



                    <div className="form-group" style={{ marginBottom: 0, flex: 1, minWidth: 200 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>Entry *</label>



                      <input className="form-control" style={{ fontSize: '0.83rem' }} placeholder="Describe what was done…"



                        value={wlForm.log_text}



                        onChange={e => setWlForm(p => ({ ...p, log_text: e.target.value }))}



                        onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleAddWorkLog(); } }} />



                    </div>



                    <button className="btn btn-primary btn-sm" onClick={handleAddWorkLog} disabled={wlSaving}



                      style={{ whiteSpace: 'nowrap', marginBottom: 2 }}>



                      {wlSaving ? 'Saving…' : 'Log'}



                    </button>



                  </div>



                </div>



              )}







            {/* Work log list */}



            {workLogs.length === 0 ? (



              <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.85rem', padding: '10px 0' }}>No work logs yet.</div>



            ) : (



              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>



                {workLogs.map(log => (



                  <div key={log.id} style={{ display: 'flex', gap: 10, padding: '9px 12px', background: 'var(--surface-2)', borderRadius: 8, border: '1px solid var(--border)', alignItems: 'flex-start' }}>



                    <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'var(--primary-lighter)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>



                      <span style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--primary)', textTransform: 'uppercase' }}>{(log.user_name || '?')[0]}</span>



                    </div>



                    <div style={{ flex: 1, minWidth: 0 }}>



                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>



                        <span style={{ fontWeight: 600, fontSize: '0.82rem' }}>{log.user_name}</span>



                        <span style={{ fontSize: '0.72rem', padding: '1px 7px', borderRadius: 10, background: 'var(--surface)', border: '1px solid var(--border)', color: 'var(--text-muted)', textTransform: 'capitalize' }}>



                          {log.log_type.replace('_', ' ')}



                        </span>



                        <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginLeft: 'auto' }}>



                          {new Date(log.logged_at).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}



                        </span>



                      </div>



                      <div style={{ fontSize: '0.83rem', color: 'var(--text-primary)', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{log.log_text}</div>



                    </div>



                    {(isPrivileged || log.user_id === user?.id || user?.id === assignModal.ownerId) && (



                      <button className="btn btn-ghost btn-icon btn-sm" data-tooltip="Delete" style={{ color: 'var(--error)', flexShrink: 0 }}



                        onClick={() => handleDeleteWorkLog(log.id)}>



                        <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4h6v2" /></svg>



                      </button>



                    )}



                  </div>



                ))}



              </div>



            )}



          </div>



        )}



      </Modal>







      {/* ── Status Update Modal ────────────────────────────────── */}



      <StatusUpdateModal state={statusModal} setState={setStatusModal} onSave={handleStatus} />

      {/* ── Revision in-progress banner (non-blocking) ─────────── */}
      {revisingId !== null && (
        <div style={{
          position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
          zIndex: 9999, display: 'flex', alignItems: 'center', gap: 10,
          background: '#1e293b', color: '#fff', borderRadius: 10,
          padding: '10px 20px', fontSize: '0.875rem', fontWeight: 500,
          boxShadow: '0 4px 20px rgba(0,0,0,0.25)', pointerEvents: 'none',
        }}>
          <span style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.35)', borderTopColor: '#fff', borderRadius: '50%', display: 'inline-block', animation: 'spin 0.7s linear infinite', flexShrink: 0 }} />
          Creating revision… please wait
        </div>
      )}







      {/* ── Bulk Upload ────────────────────────────────────────── */}



      <BulkUpload



        open={bulkOpen.open}



        onClose={() => setBulkOpen(p => ({ ...p, open: false }))}



        onSuccess={load}



        title={bulkOpen.type === 'po' ? 'Bulk Upload Purchase Orders' : 'Bulk Upload Invoices'}



        uploadUrl="/orders/bulk"



        templateUrl="/orders/template"



        queryParams={{ type: bulkOpen.type }}



        columns={bulkOpen.type === 'po' ? [



          { key: 'client_name', label: 'Client Name', required: true },



          { key: 'po_number', label: 'PO Number', required: true },



          { key: 'contact_email', label: 'Contact Email' },



          { key: 'order_date', label: 'Order Date' },



          { key: 'expected_delivery', label: 'Expected Delivery' },



          { key: 'status', label: 'Status' },



          { key: 'currency', label: 'Currency' },



          { key: 'notes', label: 'Notes' },



        ] : [



          { key: 'client_name', label: 'Client Name', required: true },



          { key: 'contact_email', label: 'Contact Email' },



          { key: 'order_date', label: 'Order Date' },



          { key: 'expected_delivery', label: 'Expected Delivery' },



          { key: 'status', label: 'Status' },



          { key: 'currency', label: 'Currency' },



          { key: 'po_number', label: 'PO / Ref Number' },



          { key: 'notes', label: 'Notes' },



        ]}



      />



    </div>



  );



}



